/* ============================================================
   V3 Homepage JS — Jersylinen
   - IntersectionObserver scroll reveal
   - Product tab switching
   - Color swatch click
   ============================================================ */

/* ============================================================
   V3 SIDEBAR CART — shared module (exposes window.v3Cart)
   Used by PDP ATC, collection quick-add, v3 quick-add, and any
   other caller via theme.js halo.updateSidebarCart delegation.
   Kill switch: set window.V3_SIDEBAR_DISABLED=true BEFORE this
   script loads to early-return and keep Ella's default sidebar.
   ============================================================ */
(function () {
  if (window.v3Cart) return; // idempotent
  if (window.V3_SIDEBAR_DISABLED) return; // rollback kill switch

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoneyLocal(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function'
          && typeof Shopify.money_format === 'string' && Shopify.money_format) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
    } catch (e) { /* fallthrough */ }
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function ensureCartStyles() {
    if (document.getElementById('v3-j-cart-style')) return;

    // Gilda Display + Lato (incl. 400 italic) are self-hosted globally via
    // snippets/self-hosted-fonts.liquid — no external font request needed here.

    var css = [
      '.halo-cart-sidebar{background:#FDFBF8 !important;}',
      '.halo-cart-sidebar .halo-sidebar-header{display:none !important;}',
      '.halo-cart-sidebar .halo-sidebar-wrapper{padding:0 !important;}',
      '.halo-cart-sidebar .halo-sidebar-close{display:none !important;}',
      '.halo-cart-sidebar .previewCartMessage{display:none !important;}',
      '.v3-j-cart{font-family:"Lato",system-ui,sans-serif;color:#4A4A4A;-webkit-font-smoothing:antialiased;display:flex;flex-direction:column;min-height:100%;}',
      '.v3-j-promo{background:#253829;color:#FDFBF8;padding:9px 16px;font-size:10px;letter-spacing:.14em;text-align:center;text-transform:uppercase;line-height:1.4;}',
      '.v3-j-promo-code{color:#c8a050;font-weight:700;}',
      '.v3-j-head{padding:22px 24px 18px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #E8E0D6;}',
      '.v3-j-head-l{display:flex;align-items:baseline;gap:10px;}',
      '.v3-j-title{font-family:"Gilda Display",Georgia,serif;font-size:22px;color:#253829;letter-spacing:.01em;line-height:1;margin:0;}',
      '.v3-j-count{font-size:11px;color:#6b6b6b;letter-spacing:.08em;}',
      '.v3-j-close{background:none;border:none;width:28px;height:28px;cursor:pointer;color:#4A4A4A;padding:0;display:flex;align-items:center;justify-content:center;}',
      '.v3-j-close:hover{color:#253829;}',
      '.v3-j-ship{padding:16px 24px 18px;background:#FAF7F2;border-bottom:1px solid #E8E0D6;}',
      '.v3-j-ship-row{display:flex;justify-content:center;align-items:center;gap:10px;font-size:13px;color:#364e41;}',
      '.v3-j-ship-label{display:inline-flex;align-items:center;gap:6px;font-weight:700;letter-spacing:.02em;}',
      '.v3-j-ship-check{color:#c8a050;font-size:20px;line-height:1;font-weight:700;}',
      '.v3-j-ship-icon{width:18px;height:18px;object-fit:contain;display:inline-block;vertical-align:middle;flex-shrink:0;}',
      '.v3-j-ship-bar{height:3px;background:#E8E0D6;border-radius:2px;overflow:hidden;}',
      '.v3-j-ship-fill{height:100%;background:#364e41;transition:width .3s ease;}',
      '.v3-j-items{flex:1;padding:0 24px;}',
      '.v3-j-item{display:flex;gap:14px;padding:20px 0;border-bottom:1px solid #E8E0D6;position:relative;}',
      '.v3-j-item:last-child{border-bottom:0;}',
      '.v3-j-img-wrap{width:84px;height:100px;flex-shrink:0;background:#EDE6DC;overflow:hidden;position:relative;text-decoration:none;display:block;}',
      '.v3-j-img-wrap img{width:100%;height:100%;object-fit:cover;display:block;}',
      '.v3-j-sale{position:absolute;top:0;left:0;background:#c0392b;color:#fff;font-size:9px;letter-spacing:.08em;padding:3px 6px;font-weight:700;line-height:1.2;}',
      '.v3-j-body{flex:1;min-width:0;padding-right:18px;}',
      '.v3-j-name{display:block;font-family:"Gilda Display",Georgia,serif;font-size:15px;line-height:1.3;color:#4A4A4A;margin:0 0 4px;text-decoration:none;}',
      '.v3-j-name:hover{color:#253829;}',
      '.v3-j-variant{font-size:11px;color:#6b6b6b;letter-spacing:.04em;margin-bottom:8px;line-height:1.3;}',
      '.v3-j-price{display:flex;align-items:baseline;gap:8px;margin-bottom:10px;}',
      '.v3-j-price-now{font-family:"Lato",sans-serif;font-size:15px;font-weight:700;color:#4A4A4A;letter-spacing:.01em;line-height:1;}',
      '.v3-j-price-now.is-sale{color:#c0392b;}',
      '.v3-j-price-was{font-size:12px;color:#a5a5a5;text-decoration:line-through;line-height:1;}',
      '.v3-j-save-badge{display:inline-block;font-size:11px;font-weight:700;color:#c0392b;letter-spacing:.02em;line-height:1;}',
      '.v3-j-qty-row{display:flex;justify-content:space-between;align-items:center;}',
      '.v3-j-qty{display:inline-flex;align-items:center;border:1px solid #E8E0D6;background:#fff;height:28px;}',
      '.v3-j-qty button{background:none;border:none;width:26px;height:26px;cursor:pointer;color:#4A4A4A;font-size:14px;padding:0;line-height:1;font-family:"Lato",sans-serif;}',
      '.v3-j-qty button:hover:not(:disabled){background:#FAF7F2;color:#253829;}',
      '.v3-j-qty button:disabled{opacity:.35;cursor:not-allowed;}',
      '.v3-j-qty-val{min-width:22px;text-align:center;font-size:13px;color:#4A4A4A;font-weight:700;}',
      '.v3-j-remove{position:absolute;top:22px;right:0;background:none;border:none;cursor:pointer;color:#9a9a9a;padding:4px;display:flex;align-items:center;justify-content:center;}',
      '.v3-j-remove:hover{color:#c0392b;}',
      '.v3-j-remove:disabled{opacity:.4;cursor:not-allowed;}',
      '.v3-j-empty{padding:60px 24px;text-align:center;}',
      '.v3-j-empty-title{font-family:"Gilda Display",Georgia,serif;font-size:20px;color:#253829;margin:0 0 8px;}',
      '.v3-j-empty-text{font-size:12px;color:#6b6b6b;margin:0 0 24px;font-style:italic;font-family:"Gilda Display",serif;}',
      '.v3-j-foot{padding:20px 24px 24px;background:#FAF7F2;border-top:1px solid #E8E0D6;}',
      '.v3-j-line{display:flex;justify-content:space-between;align-items:baseline;font-size:12px;color:#6b6b6b;margin-bottom:6px;line-height:1.3;}',
      '.v3-j-line.is-savings{color:#c0392b;font-weight:700;margin-bottom:10px;}',
      '.v3-j-total{display:flex;justify-content:space-between;align-items:baseline;padding-top:12px;border-top:1px solid #E8E0D6;margin-bottom:4px;}',
      '.v3-j-total-label{font-size:12px;color:#4A4A4A;letter-spacing:.08em;text-transform:uppercase;font-weight:700;}',
      '.v3-j-total-val{font-family:"Lato",sans-serif;font-size:22px;color:#253829;font-weight:700;letter-spacing:.01em;line-height:1;}',
      '.v3-j-tax{font-size:11px;color:#8a8a8a;font-style:italic;font-family:"Gilda Display",serif;margin:0 0 16px;text-align:right;line-height:1.3;}',
      '.v3-j-checkout{width:100%;background:#364e41;color:#fff;border:none;padding:15px;font-family:"Lato",sans-serif;font-size:12px;letter-spacing:.14em;text-transform:uppercase;font-weight:700;cursor:pointer;margin-bottom:12px;transition:background .2s;display:block;text-align:center;text-decoration:none;line-height:1.2;}',
      '.v3-j-checkout:hover{background:#253829;color:#fff;}',
      '.v3-j-or{display:flex;align-items:center;gap:10px;margin:10px 0 12px;}',
      '.v3-j-or-line{flex:1;height:1px;background:#E8E0D6;}',
      '.v3-j-or-text{font-size:10px;color:#9a9a9a;letter-spacing:.14em;text-transform:uppercase;white-space:nowrap;}',
      '.v3-j-express{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px;}',
      '.v3-j-express-btn{border:none;height:40px;font-weight:700;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center;letter-spacing:.02em;font-family:"Lato",sans-serif;text-decoration:none;}',
      '.v3-j-express-btn.shoppay{background:#5A31F4;color:#fff;}',
      '.v3-j-express-btn.shoppay em{font-style:italic;margin-left:2px;font-weight:700;}',
      '.v3-j-express-btn.paypal{background:#FFC439;color:#253b80;}',
      '.v3-j-express-btn.paypal em{font-style:italic;font-weight:700;}',
      '.v3-j-express-btn.paypal em:last-child{color:#179bd7;}',
      '.v3-j-express-btn:hover{opacity:.92;}',
      '.v3-j-viewcart{display:block;text-align:center;font-size:11px;color:#6b6b6b;letter-spacing:.1em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px;padding:6px;}',
      '.v3-j-viewcart:hover{color:#253829;}',
      '.v3-j-trust{display:flex;justify-content:center;gap:18px;margin-top:14px;padding-top:14px;border-top:1px solid #E8E0D6;font-size:10px;color:#6b6b6b;letter-spacing:.04em;flex-wrap:wrap;}',
      '.v3-j-trust-item{display:inline-flex;align-items:center;gap:6px;}',
      '.v3-j-trust-icon{width:14px;height:14px;object-fit:contain;display:inline-block;flex-shrink:0;}',
      '@media (max-width:420px){',
      '  .v3-j-head{padding:18px 18px 14px;}',
      '  .v3-j-items{padding:0 18px;}',
      '  .v3-j-foot{padding:18px 18px 20px;}',
      '  .v3-j-ship{padding:12px 18px 14px;}',
      '  .v3-j-trust{gap:12px;}',
      '  .v3-j-ship-icon{width:20px;height:20px;}',
      '  .v3-j-ship-check{font-size:22px;}',
      '  .v3-j-ship-row{font-size:14px;}',
      '}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'v3-j-cart-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* A cart line is individually addressable (can't be merged / operated by
     variant total) when it carries line-item properties or a selling plan —
     /cart/update.js keyed by variant id can't disambiguate such lines. */
  function cartLineHasIdentity(item) {
    if (item.selling_plan_allocation) return true;
    var p = item.properties;
    if (p) {
      if (Array.isArray(p)) { if (p.length) return true; }
      else { for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) return true; } }
    }
    return false;
  }

  /* Collapse Shopify's BXGY line splits (same variant → discounted line +
     full-price line, same variant_id, different keys) into ONE display row
     per variant, so the shopper sees a single row whose quantity == the
     variant total, and +/−/remove can operate on the whole variant via
     /cart/update.js. If ANY line of a variant carries properties / a selling
     plan, that ENTIRE variant falls back to per-line ('key') mode.
     NOTE: footer savings must still be computed from the raw cart.items —
     never from this grouped list. */
  function groupCartItems(items) {
    if (!items || !items.length) return [];
    var variantBlocked = {};
    for (var a = 0; a < items.length; a++) {
      if (cartLineHasIdentity(items[a])) variantBlocked[String(items[a].variant_id)] = true;
    }
    var out = [];
    var idx = {};  /* variantId -> index in out (variant mode only) */
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var vid = String(it.variant_id);
      var lineOrig = (it.original_line_price != null) ? it.original_line_price
        : ((it.original_price != null ? it.original_price : (it.price || 0)) * it.quantity);
      var lineFin = (it.final_line_price != null) ? it.final_line_price
        : ((it.final_price != null ? it.final_price : (it.price || 0)) * it.quantity);

      if (variantBlocked[vid]) {
        var kc = {};
        for (var kk in it) { if (Object.prototype.hasOwnProperty.call(it, kk)) kc[kk] = it[kk]; }
        kc._ctl = 'key';
        kc.original_line_price = lineOrig;
        kc.final_line_price = lineFin;
        out.push(kc);
        continue;
      }

      if (idx[vid] != null) {
        var tgt = out[idx[vid]];
        tgt.quantity += it.quantity;
        tgt.original_line_price += lineOrig;
        tgt.final_line_price += lineFin;
      } else {
        var vc = {};
        for (var kk2 in it) { if (Object.prototype.hasOwnProperty.call(it, kk2)) vc[kk2] = it[kk2]; }
        vc._ctl = 'variant';
        vc.original_line_price = lineOrig;
        vc.final_line_price = lineFin;
        idx[vid] = out.length;
        out.push(vc);
      }
    }
    return out;
  }

  function renderCartItemHTML(item, index) {
    var optionsStr = '';
    if (item.options_with_values && item.options_with_values.length) {
      var visible = item.options_with_values.filter(function (o) {
        return !(o.name === 'Title' && o.value === 'Default Title');
      });
      optionsStr = visible.map(function (o) { return esc(o.value); }).join(' · ');
    }

    var imageSrc = item.image || (item.featured_image && item.featured_image.url) || '';
    if (imageSrc) {
      imageSrc = imageSrc.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_200x$1$2');
    }

    /* Fallback chain so ANY cart JSON source renders correctly — the Liquid
       bootstrap and the AJAX endpoints don't expose an identical field set.
       hasDiscount uses < (not !==) so a missing field can never fabricate a
       strikethrough. */
    var unitOriginal = (item.original_price != null) ? item.original_price
      : ((item.price != null) ? item.price : 0);
    var unitFinal = (item.final_price != null) ? item.final_price
      : ((item.discounted_price != null) ? item.discounted_price : unitOriginal);
    var lineOriginal = (item.original_line_price != null) ? item.original_line_price : (unitOriginal * item.quantity);
    var lineFinal = (item.final_line_price != null) ? item.final_line_price : (unitFinal * item.quantity);

    var hasDiscount = lineFinal < lineOriginal;
    var lineSavings = Math.max(0, lineOriginal - lineFinal);
    var isVariantMode = (item._ctl === 'variant');
    var discountPct = 0;
    if (hasDiscount && lineOriginal) {
      discountPct = Math.round((lineOriginal - lineFinal) / lineOriginal * 100);
    }

    var priceHTML;
    if (hasDiscount && isVariantMode) {
      /* Merged variant row: its units have MIXED prices (some discounted, some
         full) so a single "final unit price" / strikethrough is meaningless.
         Show the true unit price + a "Save $X" badge for the line's total saving. */
      priceHTML =
        '<div class="v3-j-price">' +
          '<span class="v3-j-price-now">' + formatMoneyLocal(unitOriginal) + '</span>' +
          '<span class="v3-j-save-badge">Save ' + formatMoneyLocal(lineSavings) + '</span>' +
        '</div>';
    } else if (hasDiscount) {
      priceHTML =
        '<div class="v3-j-price">' +
          '<span class="v3-j-price-now is-sale">' + formatMoneyLocal(unitFinal) + '</span>' +
          '<span class="v3-j-price-was">' + formatMoneyLocal(unitOriginal) + '</span>' +
        '</div>';
    } else {
      priceHTML =
        '<div class="v3-j-price">' +
          '<span class="v3-j-price-now">' + formatMoneyLocal(unitFinal) + '</span>' +
        '</div>';
    }

    /* Image −% badge only for non-merged (per-line) real discounts. */
    var saleBadge = (hasDiscount && !isVariantMode && discountPct > 0)
      ? '<div class="v3-j-sale">-' + discountPct + '%</div>'
      : '';

    var variantHTML = optionsStr
      ? '<div class="v3-j-variant">' + optionsStr + '</div>'
      : '';

    return (
      '<div class="v3-j-item"' +
        ' data-line-key="' + esc(item.key) + '"' +
        ' data-variant-id="' + esc(item.variant_id) + '"' +
        ' data-ctl="' + (isVariantMode ? 'variant' : 'key') + '"' +
        ' data-base-qty="' + (item.quantity || 0) + '"' +
        ' data-line-original="' + (lineOriginal || 0) + '"' +
        ' data-line-final="' + (lineFinal || 0) + '"' +
        ' data-unit-final="' + (unitFinal || 0) + '"' +
        ' data-unit-original="' + (unitOriginal || 0) + '"' +
      '>' +
        '<a href="' + esc(item.url) + '" class="v3-j-img-wrap">' +
          (imageSrc ? '<img src="' + esc(imageSrc) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
          saleBadge +
        '</a>' +
        '<div class="v3-j-body">' +
          '<a href="' + esc(item.url) + '" class="v3-j-name">' + esc(item.product_title) + '</a>' +
          variantHTML +
          priceHTML +
          '<div class="v3-j-qty-row">' +
            '<div class="v3-j-qty">' +
              '<button type="button" data-qty-dec="' + esc(item.key) + '" aria-label="Decrease">−</button>' +
              '<span class="v3-j-qty-val">' + item.quantity + '</span>' +
              '<button type="button" data-qty-inc="' + esc(item.key) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="v3-j-remove" data-remove-line="' + esc(item.key) + '" aria-label="Remove">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>'
    );
  }

  function renderSidebarShell(cart) {
    var itemCount = cart.item_count || 0;
    var itemLabel = itemCount === 1 ? '1 item' : itemCount + ' items';

    var header =
      '<div class="v3-j-promo">Pieces that pair beautifully — bedding + any companion saves $10</div>' +
      '<div class="v3-j-head">' +
        '<div class="v3-j-head-l">' +
          '<h2 class="v3-j-title">Your Cart</h2>' +
          '<span class="v3-j-count">' + itemLabel + '</span>' +
        '</div>' +
        '<button type="button" class="v3-j-close" data-close-cart-sidebar aria-label="Close">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';

    if (!cart.items || cart.items.length === 0) {
      return (
        '<div class="v3-j-cart">' +
          header +
          '<div class="v3-j-empty">' +
            '<p class="v3-j-empty-title">Your cart is empty</p>' +
            '<p class="v3-j-empty-text">Start building a bedroom you love.</p>' +
            '<a href="/collections/all" class="v3-j-checkout">Continue Shopping</a>' +
          '</div>' +
        '</div>'
      );
    }

    var shipRow =
      '<div class="v3-j-ship">' +
        '<div class="v3-j-ship-row">' +
          '<span class="v3-j-ship-label">' +
            '<img src="https://cdn.shopify.com/s/files/1/0674/8346/7945/files/icon-shipping.webp?v=1758161057" alt="" class="v3-j-ship-icon" width="18" height="18">' +
            'You qualify for free shipping' +
          '</span>' +
          '<span class="v3-j-ship-check">✓</span>' +
        '</div>' +
      '</div>';

    var itemsHTML =
      '<div class="v3-j-items">' +
        groupCartItems(cart.items).map(renderCartItemHTML).join('') +
      '</div>';

    /* Savings = Σ original_line_price − total_price, computed FROM THE LINE
       ITEMS. Do NOT trust cart-level fields for this:
       • items_subtotal_price = Σ FINAL line prices (line discounts already
         removed) — using it makes savings ≡ 0 for line-level discounts.
       • original_total_price is missing from some cart JSON sources (the
         Liquid {{ cart | json }} bootstrap in halo-cart-sidebar.liquid), so
         any fallback chain through cart-level fields collapses to
         subtotal == total → "You save" hidden — which is exactly the
         flash-then-vanish bug: /cart.js paints savings, the next paint from
         a source lacking the field wipes it.
       Per-line original_line_price exists in /cart.js, /cart/change.js AND
       the Liquid bootstrap, so this is source-agnostic. It also matches
       updateOptimisticTotals (Σ unitOriginal×qty), so optimistic and
       authoritative paints agree: Subtotal − You save = Total. */
    var originalTotal = 0;
    for (var oi = 0; oi < cart.items.length; oi++) {
      var oit = cart.items[oi];
      var lineOrig =
        (oit.original_line_price != null) ? oit.original_line_price :
        (oit.original_price != null)      ? (oit.original_price * oit.quantity) :
        (oit.line_price != null)          ? oit.line_price :
                                            ((oit.price || 0) * oit.quantity);
      originalTotal += lineOrig;
    }
    /* If the server does report a larger pre-discount total (e.g. a pure
       cart-level field this loop can't see), trust the larger value. */
    if (cart.original_total_price != null && cart.original_total_price > originalTotal) {
      originalTotal = cart.original_total_price;
    }
    var savings = Math.max(0, originalTotal - cart.total_price);
    var subtotalDisplay = originalTotal;

    var totalsHTML =
      '<div class="v3-j-foot">' +
        '<div class="v3-j-line"><span>Subtotal</span><span class="v3-j-subtotal-val">' + formatMoneyLocal(subtotalDisplay) + '</span></div>' +
        '<div class="v3-j-line is-savings v3-j-savings-line"' + (savings > 0 ? '' : ' style="display:none;"') + '><span>You save</span><span class="v3-j-savings-val">−' + formatMoneyLocal(savings) + '</span></div>' +
        '<div class="v3-j-total">' +
          '<span class="v3-j-total-label">Total</span>' +
          '<span class="v3-j-total-val">' + formatMoneyLocal(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="v3-j-tax">Taxes calculated at checkout</p>' +
        '<a href="/checkout" class="v3-j-checkout"><span class="v3-j-checkout-label">Checkout → </span><span class="v3-j-checkout-amt">' + formatMoneyLocal(cart.total_price) + '</span></a>' +
        '<a href="/cart" class="v3-j-viewcart">View Full Cart</a>' +
        '<div class="v3-j-trust">' +
          '<span class="v3-j-trust-item"><img src="https://cdn.shopify.com/s/files/1/0674/8346/7945/files/icon-checkmark_c0923e82-f299-48ff-a3ba-41a3a0d88e24.png?v=1775532831" alt="" class="v3-j-trust-icon">Free shipping</span>' +
          '<span class="v3-j-trust-item"><img src="https://cdn.shopify.com/s/files/1/0674/8346/7945/files/icon-return_17a96b02-c221-4d21-a6b4-51959adf4251.webp?v=1775528732" alt="" class="v3-j-trust-icon">30-day returns</span>' +
          '<span class="v3-j-trust-item"><img src="https://cdn.shopify.com/s/files/1/0674/8346/7945/files/icon-secure.webp?v=1775528732" alt="" class="v3-j-trust-icon">Secure pay</span>' +
        '</div>' +
      '</div>';

    return (
      '<div class="v3-j-cart">' +
        header + shipRow + itemsHTML + totalsHTML +
      '</div>'
    );
  }

  /* Module-level state for cart-line race protection (survives sidebar re-renders). */
  /* Monotonic cart-state version. Bumped after EVERY successful cart mutation
     (add / change / remove). refresh() records the version when its GET starts;
     if a mutation lands while the GET is in flight, the GET's snapshot predates
     the mutation → its render is discarded and ONE fresh fetch converges. This
     is what stops a slow /cart.js from resurrecting a just-removed line. */
  var _cartMutSeq = 0;
  function noteCartMutation() { _cartMutSeq++; }
  var pendingLineChanges = {};   /* { lineKey: AbortController } */
  var lineRequestSeq    = {};   /* { lineKey: monotonic seq counter } */
  var lineDebounceTimers = {};   /* { lineKey: setTimeout id } */

  /* Inventory cache: { variantId: maxQty }. Populated from:
     1) .v3-pc__meta JSON embedded in product cards on the page
     2) /products/{handle}.js fetched when the sidebar renders
     3) Reactive detection from /cart/change.js responses
     Variants without inventory tracking (or 'continue' policy) = 99999 = no limit. */
  window.v3VariantInventory = window.v3VariantInventory || {};
  var inventoryFetchedHandles = {};
  function populateInventoryCache() {
    var nodes = document.querySelectorAll('.v3-pc__meta');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent);
        if (data && data.variants_inv) {
          for (var vid in data.variants_inv) {
            if (Object.prototype.hasOwnProperty.call(data.variants_inv, vid)) {
              window.v3VariantInventory[vid] = data.variants_inv[vid];
            }
          }
        }
      } catch (e) { /* skip malformed */ }
    }
  }
  function fetchInventoryForCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var handleMap = {};
    cart.items.forEach(function (item) {
      if (!item.handle) return;
      if (inventoryFetchedHandles[item.handle]) return;
      if (item.variant_id in window.v3VariantInventory) return;
      handleMap[item.handle] = true;
    });
    Object.keys(handleMap).forEach(function (handle) {
      inventoryFetchedHandles[handle] = true;
      fetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (!product || !product.variants) return;
          product.variants.forEach(function (v) {
            if (v.inventory_management && v.inventory_policy === 'deny') {
              window.v3VariantInventory[v.id] = Math.max(0, v.inventory_quantity);
            } else {
              window.v3VariantInventory[v.id] = 99999;
            }
          });
          updatePlusButtonStates();
        })
        .catch(function () { /* silent */ });
    });
  }
  /* Sum a variant's qty across ALL sidebar lines. A variant can occupy >1 line
     when Shopify splits a partial automatic discount into a discounted line +
     a full-price line. Excludes lines being removed. */
  function getVariantQtyInSidebar(wrapper, variantId) {
    if (!wrapper) wrapper = document.querySelector('.previewCart-wrapper');
    if (!wrapper || !variantId) return 0;
    var total = 0;
    wrapper.querySelectorAll('.v3-j-item[data-variant-id="' + variantId + '"]').forEach(function (el) {
      if (el.dataset.removing === 'true') return;
      var q = el.querySelector('.v3-j-qty-val');
      total += q ? (parseInt(q.textContent, 10) || 0) : 0;
    });
    return total;
  }
  function updatePlusButtonStates() {
    var wrapper = document.querySelector('.previewCart-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.v3-j-item').forEach(function (lineEl) {
      var variantId = lineEl.dataset.variantId;
      var max = getMaxQtyForVariant(variantId);
      /* Gate on the variant's TOTAL qty across all lines, not this single line.
         When max is unknown (99999) the sum stays well below it → never disabled. */
      var variantTotal = getVariantQtyInSidebar(wrapper, variantId);
      var incBtn = lineEl.querySelector('[data-qty-inc]');
      if (incBtn) incBtn.disabled = (variantTotal >= max);
    });
  }
  function getMaxQtyForVariant(variantId) {
    if (!variantId) return 99999;
    var v = window.v3VariantInventory[variantId];
    return (typeof v === 'number') ? v : 99999;
  }

  /* Map of { variantId: total qty currently in cart for that variant }.
     Used by the Quick-Shop modal to compute "how many more can the user
     still add" = total_inventory − already_in_cart. Updated authoritatively
     from every /cart.js response (renderSidebarContent / refresh) AND
     OPTIMISTICALLY in the Quick-Shop submit handler (so a quick double-click
     can't bypass the check while /cart/add.js is still in flight). */
  window.v3CartItemQtyByVariant = window.v3CartItemQtyByVariant || {};
  function updateCartQtyMap(cart) {
    var map = {};
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity;
      }
    }
    window.v3CartItemQtyByVariant = map;
  }

  /* Maximum quantity the user can STILL add for this variant given
     (a) total inventory and (b) what is already in their cart.
     Returns 99999 when inventory is unknown / not tracked — preserves
     legitimate-purchase path for unmanaged or oversellable products. */
  function getRemainingAddableQty(variantId) {
    if (!variantId) return 99999;
    var max = getMaxQtyForVariant(variantId);
    if (max >= 99999) return 99999;
    var inCart = window.v3CartItemQtyByVariant[variantId] || 0;
    return Math.max(0, max - inCart);
  }
  /* Expose for the Quick-Shop modal in IIFE 2 (different lexical scope). */
  window.v3GetRemainingAddable = getRemainingAddableQty;

  /* Recompute and apply totals from the current optimistic DOM state, so the
     subtotal / savings / total / item count / checkout amount all update
     INSTANTLY on each click — no waiting for /cart/change.js. The next server
     response will fully re-render with authoritative values (which should
     match in 99% of cases; cart-level discounts may correct slightly). */
  function updateOptimisticTotals(wrapper) {
    if (!wrapper) wrapper = document.querySelector('.previewCart-wrapper');
    if (!wrapper) return;

    var subtotal = 0;  /* sum of original_price × qty (line-discount-aware via per-line data) */
    var total = 0;     /* sum of final_price × qty */
    var lineCount = 0;

    var items = wrapper.querySelectorAll('.v3-j-item');
    for (var i = 0; i < items.length; i++) {
      var lineEl = items[i];
      /* Lines being deleted: excluded from totals (treated as qty=0) */
      if (lineEl.dataset.removing === 'true') continue;

      var unitFinal    = parseInt(lineEl.dataset.unitFinal    || '0', 10) || 0;
      var unitOriginal = parseInt(lineEl.dataset.unitOriginal || lineEl.dataset.unitFinal || '0', 10) || unitFinal;
      var qtyEl = lineEl.querySelector('.v3-j-qty-val');
      var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 0) : 0;
      if (qty <= 0) continue;

      var baseQty  = parseInt(lineEl.dataset.baseQty || '', 10);
      var lineOrig = parseInt(lineEl.dataset.lineOriginal || '', 10);
      var lineFin  = parseInt(lineEl.dataset.lineFinal || '', 10);

      if (lineEl.dataset.ctl === 'variant' && !isNaN(baseQty) && !isNaN(lineOrig) && !isNaN(lineFin)) {
        /* Incremental model for a merged variant row. A capped BXGY discount
           covers a FIXED number of units, so every unit added beyond the
           rendered baseline is full price: it contributes unitOriginal to BOTH
           subtotal and total, leaving "You save" unchanged (no flash/jump).
           The authoritative server render replaces this shortly after. */
        var delta = qty - baseQty;
        subtotal += lineOrig + delta * unitOriginal;
        total    += lineFin  + delta * unitOriginal;
      } else {
        subtotal += unitOriginal * qty;
        total    += unitFinal    * qty;
      }
      lineCount += qty;
    }

    var savings = Math.max(0, subtotal - total);

    /* Item count in header (e.g., "3 items") */
    var countEl = wrapper.querySelector('.v3-j-count');
    if (countEl) countEl.textContent = (lineCount === 1 ? '1 item' : lineCount + ' items');

    /* Subtotal */
    var subtotalEl = wrapper.querySelector('.v3-j-subtotal-val');
    if (subtotalEl) subtotalEl.textContent = formatMoneyLocal(subtotal);

    /* Savings line (show / hide + amount) */
    var savingsLine = wrapper.querySelector('.v3-j-savings-line');
    var savingsValEl = wrapper.querySelector('.v3-j-savings-val');
    if (savingsLine) savingsLine.style.display = (savings > 0) ? '' : 'none';
    if (savingsValEl) savingsValEl.textContent = '−' + formatMoneyLocal(savings);

    /* Total */
    var totalValEl = wrapper.querySelector('.v3-j-total-val');
    if (totalValEl) totalValEl.textContent = formatMoneyLocal(total);

    /* Checkout button label */
    var checkoutAmtEl = wrapper.querySelector('.v3-j-checkout-amt');
    if (checkoutAmtEl) checkoutAmtEl.textContent = formatMoneyLocal(total);
  }

  /* Brief inventory-limit feedback near the qty controls of a line item */
  function showInventoryLimitFeedback(lineEl, max) {
    if (!lineEl) return;
    var existing = lineEl.querySelector('.v3-j-stock-msg');
    if (existing) existing.remove();
    var msg = document.createElement('div');
    msg.className = 'v3-j-stock-msg';
    msg.textContent = 'Only ' + max + ' available';
    msg.style.cssText = 'color:#c75050;font-size:11px;margin-top:6px;font-weight:600;letter-spacing:.02em;';
    var body = lineEl.querySelector('.v3-j-body');
    if (body) body.appendChild(msg);
    setTimeout(function () { if (msg.parentNode) msg.remove(); }, 2000);
  }

  function v3ChangeLineQty(key, newQty, requestedQty) {
    if (pendingLineChanges[key]) {
      try { pendingLineChanges[key].abort(); } catch (e) { /* noop */ }
    }
    var controller = ('AbortController' in window) ? new AbortController() : null;
    if (controller) pendingLineChanges[key] = controller;

    var mySeq = (lineRequestSeq[key] || 0) + 1;
    lineRequestSeq[key] = mySeq;

    var fetchOpts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    };
    if (controller) fetchOpts.signal = controller.signal;

    return fetch('/cart/change.js', fetchOpts)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + r.status); });
        return r.json();
      })
      .then(function (updatedCart) {
        if (lineRequestSeq[key] !== mySeq) return updatedCart;
        if (pendingLineChanges[key] === controller) delete pendingLineChanges[key];
        noteCartMutation();  /* cart state changed — invalidate in-flight GETs */

        var asked = (typeof requestedQty === 'number') ? requestedQty : newQty;
        if (asked > 0 && updatedCart && updatedCart.items) {
          var serverItem = null;
          for (var i = 0; i < updatedCart.items.length; i++) {
            if (updatedCart.items[i].key === key) { serverItem = updatedCart.items[i]; break; }
          }
          if (serverItem) {
            var variantLineCount = 0;
            for (var j = 0; j < updatedCart.items.length; j++) {
              if (updatedCart.items[j].variant_id === serverItem.variant_id) variantLineCount++;
            }
            /* Only treat "got fewer than asked" as a real stock cap when this
               variant occupies a SINGLE cart line. When it spans >1 line, a short
               line is discount reallocation (Shopify split), NOT a stock limit —
               caching a low inventory here is what permanently disables "+". */
            if (variantLineCount <= 1 && serverItem.quantity < asked) {
              window.v3VariantInventory[serverItem.variant_id] = serverItem.quantity;
              var lineEl = document.querySelector('.previewCart-wrapper [data-line-key="' + key + '"]');
              showInventoryLimitFeedback(lineEl, serverItem.quantity);
            }
          }
        }

        updateCartBadges(updatedCart);
        renderSidebarContent(updatedCart);
        if (typeof window.essentialInitCartBanners === 'function') {
          try { window.essentialInitCartBanners(); } catch (e) { /* noop */ }
        }
        return updatedCart;
      })
      .catch(function (err) {
        if (pendingLineChanges[key] === controller) delete pendingLineChanges[key];
        throw err;
      });
  }

  function v3DebouncedChangeLineQty(key, newQty) {
    if (lineDebounceTimers[key]) clearTimeout(lineDebounceTimers[key]);
    lineDebounceTimers[key] = setTimeout(function () {
      delete lineDebounceTimers[key];
      v3ChangeLineQty(key, newQty, newQty);
    }, 300);
  }

  /* Variant-total mutation. Unlike v3ChangeLineQty (which operates on ONE
     Shopify line key), this sets the TOTAL quantity for a variant across all
     of its lines via /cart/update.js {updates:{"<variantId>": newTotal}}.
     Shopify re-splits / re-allocates the BXGY discount itself, so this is the
     correct primitive for a merged (variant-mode) sidebar row: one atomic
     request, no stale-key / re-split races. Reuses the same race-protection
     tables as v3ChangeLineQty, namespaced with a 'v:' prefix (Shopify line
     keys contain ':' + hex and never collide with our variant ids). */
  function v3SetVariantQty(variantId, newTotal, requestedTotal) {
    var vkey = 'v:' + variantId;
    if (pendingLineChanges[vkey]) {
      try { pendingLineChanges[vkey].abort(); } catch (e) { /* noop */ }
    }
    var controller = ('AbortController' in window) ? new AbortController() : null;
    if (controller) pendingLineChanges[vkey] = controller;

    var mySeq = (lineRequestSeq[vkey] || 0) + 1;
    lineRequestSeq[vkey] = mySeq;

    var updates = {};
    updates[String(variantId)] = newTotal;

    var fetchOpts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    };
    if (controller) fetchOpts.signal = controller.signal;

    return fetch('/cart/update.js', fetchOpts)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + r.status); });
        return r.json();
      })
      .then(function (updatedCart) {
        if (lineRequestSeq[vkey] !== mySeq) return updatedCart;
        if (pendingLineChanges[vkey] === controller) delete pendingLineChanges[vkey];
        noteCartMutation();  /* cart state changed — invalidate in-flight GETs */

        var asked = (typeof requestedTotal === 'number') ? requestedTotal : newTotal;
        if (asked > 0 && updatedCart && updatedCart.items) {
          /* Variant mode is unambiguous: sum ALL lines of this variant; if the
             server total is short of what we asked, it's a genuine stock cap. */
          var serverTotal = 0, want = String(variantId);
          for (var i = 0; i < updatedCart.items.length; i++) {
            if (String(updatedCart.items[i].variant_id) === want) serverTotal += updatedCart.items[i].quantity;
          }
          if (serverTotal < asked) {
            window.v3VariantInventory[variantId] = serverTotal;
            var lineEl = document.querySelector('.previewCart-wrapper .v3-j-item[data-variant-id="' + variantId + '"]');
            showInventoryLimitFeedback(lineEl, serverTotal);
          }
        }

        updateCartBadges(updatedCart);
        renderSidebarContent(updatedCart);
        if (typeof window.essentialInitCartBanners === 'function') {
          try { window.essentialInitCartBanners(); } catch (e) { /* noop */ }
        }
        return updatedCart;
      })
      .catch(function (err) {
        if (pendingLineChanges[vkey] === controller) delete pendingLineChanges[vkey];
        throw err;
      });
  }

  function v3DebouncedSetVariantQty(variantId, newTotal) {
    var vkey = 'v:' + variantId;
    if (lineDebounceTimers[vkey]) clearTimeout(lineDebounceTimers[vkey]);
    lineDebounceTimers[vkey] = setTimeout(function () {
      delete lineDebounceTimers[vkey];
      v3SetVariantQty(variantId, newTotal, newTotal);
    }, 300);
  }

  function v3IsAbortError(err) {
    return err && (err.name === 'AbortError' || (err.message || '').indexOf('aborted') >= 0);
  }

  /* Bulletproof delegated cart-sidebar click handler. Attached ONCE to
     document on first call. essentialInitCartBanners / cart-coupon-discount /
     any other DOM rewrite cannot orphan this listener because document is
     never replaced.
     stopPropagation is applied ONLY to mutation buttons (remove / qty inc /
     qty dec) to prevent Ella's legacy $doc handlers (theme.js:3833) and any
     stale V3 wrapper-level delegation from double-firing. The close button
     intentionally bubbles so GA4 / Klaviyo / Essential Apps can observe it. */
  var v3SidebarDelegatedInstalled = false;
  function installSidebarDelegation() {
    if (v3SidebarDelegatedInstalled) return;
    v3SidebarDelegatedInstalled = true;

    document.addEventListener('click', function (e) {
      /* Only react inside the cart sidebar. Cheap early-exit for all other clicks. */
      if (!e.target.closest('#halo-cart-sidebar')) return;

      var wrapper = document.querySelector('.previewCart-wrapper');
      var el;

      el = e.target.closest('[data-remove-line]');
      if (el) {
        e.preventDefault();
        e.stopPropagation();
        var key = el.getAttribute('data-remove-line');
        var lineEl = el.closest('.v3-j-item');
        var ctl = lineEl ? lineEl.dataset.ctl : 'key';
        var vid = lineEl ? lineEl.dataset.variantId : null;
        if (lineDebounceTimers[key]) { clearTimeout(lineDebounceTimers[key]); delete lineDebounceTimers[key]; }
        if (vid && lineDebounceTimers['v:' + vid]) { clearTimeout(lineDebounceTimers['v:' + vid]); delete lineDebounceTimers['v:' + vid]; }
        if (lineEl) {
          lineEl.dataset.removing = 'true';
          /* 150ms 高度+不透明度收缩，避免 display:none 让下方行突然跳上来；
             reduced-motion 用户直接隐藏。失败时 catch 反向清掉这些 inline style。 */
          var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (prefersReduced) {
            lineEl.style.display = 'none';
          } else {
            var h = lineEl.offsetHeight;
            lineEl.style.overflow = 'hidden';
            lineEl.style.transition = 'height 150ms ease, opacity 100ms ease, margin 150ms ease, padding 150ms ease';
            lineEl.style.height = h + 'px';
            requestAnimationFrame(function () {
              lineEl.style.height = '0';
              lineEl.style.opacity = '0';
              lineEl.style.marginTop = '0';
              lineEl.style.marginBottom = '0';
              lineEl.style.paddingTop = '0';
              lineEl.style.paddingBottom = '0';
            });
          }
        }
        el.disabled = true;
        if (wrapper) updateOptimisticTotals(wrapper);
        (ctl === 'variant' ? v3SetVariantQty(vid, 0, 0) : v3ChangeLineQty(key, 0))
          .catch(function (err) {
            if (v3IsAbortError(err)) return;
            if (lineEl) {
              lineEl.style.display = '';
              lineEl.style.overflow = '';
              lineEl.style.transition = '';
              lineEl.style.height = '';
              lineEl.style.opacity = '';
              lineEl.style.marginTop = '';
              lineEl.style.marginBottom = '';
              lineEl.style.paddingTop = '';
              lineEl.style.paddingBottom = '';
              delete lineEl.dataset.removing;
            }
            el.disabled = false;
            if (wrapper) updateOptimisticTotals(wrapper);
            /* The row was restored because the remove POST FAILED (429/5xx/
               network) — the item is genuinely still in the cart. Without
               feedback this silent restore is indistinguishable from a bug
               (“disappears 0.5s then comes back”). Tell the user. */
            if (lineEl) {
              var failMsg = lineEl.querySelector('.v3-j-stock-msg');
              if (failMsg) failMsg.remove();
              failMsg = document.createElement('div');
              failMsg.className = 'v3-j-stock-msg';
              failMsg.textContent = "Couldn't remove — please try again";
              failMsg.style.cssText = 'color:#c75050;font-size:11px;margin-top:6px;font-weight:600;letter-spacing:.02em;';
              var failBody = lineEl.querySelector('.v3-j-body');
              if (failBody) failBody.appendChild(failMsg);
              setTimeout(function () { if (failMsg.parentNode) failMsg.remove(); }, 2500);
            }
            if (window.console) console.warn('[v3Cart] remove failed — line restored', err);
          });
        return;
      }

      el = e.target.closest('[data-qty-dec]');
      if (el) {
        e.preventDefault();
        e.stopPropagation();
        var key = el.getAttribute('data-qty-dec');
        var lineEl = el.closest('.v3-j-item');
        var ctl = lineEl ? lineEl.dataset.ctl : 'key';
        var variantId = lineEl ? lineEl.dataset.variantId : null;
        var valEl = el.parentElement.querySelector('.v3-j-qty-val');
        var current = parseInt(valEl.textContent, 10) || 1;
        if (current <= 1) return;
        var newQty = current - 1;
        valEl.textContent = newQty;
        if (wrapper) updateOptimisticTotals(wrapper);
        if (lineEl) {
          var existing = lineEl.querySelector('.v3-j-stock-msg');
          if (existing) existing.remove();
        }
        var incBtn = lineEl ? lineEl.querySelector('[data-qty-inc]') : null;
        if (incBtn) incBtn.disabled = false;
        /* variant mode: newQty is the merged row's number = variant total. */
        if (ctl === 'variant') v3DebouncedSetVariantQty(variantId, newQty);
        else v3DebouncedChangeLineQty(key, newQty);
        return;
      }

      el = e.target.closest('[data-qty-inc]');
      if (el) {
        e.preventDefault();
        e.stopPropagation();
        var key = el.getAttribute('data-qty-inc');
        var lineEl = el.closest('.v3-j-item');
        var ctl = lineEl ? lineEl.dataset.ctl : 'key';
        var variantId = lineEl ? lineEl.dataset.variantId : null;
        var max = getMaxQtyForVariant(variantId);
        var valEl = el.parentElement.querySelector('.v3-j-qty-val');
        var current = parseInt(valEl.textContent, 10) || 1;
        /* Compare the variant's TOTAL qty across all lines (not this single line)
           against max — a variant can occupy multiple lines (discount split). */
        var variantTotal = getVariantQtyInSidebar(wrapper, variantId);

        if (variantTotal >= max) {
          showInventoryLimitFeedback(lineEl, max);
          el.disabled = true;
          return;
        }

        var newQty = current + 1;
        valEl.textContent = newQty;
        if (wrapper) updateOptimisticTotals(wrapper);
        if ((variantTotal + 1) >= max) el.disabled = true;
        /* variant mode: the merged row's number IS the variant total, so
           newQty is the new total to send to /cart/update.js. */
        if (ctl === 'variant') v3DebouncedSetVariantQty(variantId, newQty);
        else v3DebouncedChangeLineQty(key, newQty);
        return;
      }

      el = e.target.closest('[data-close-cart-sidebar]');
      if (el) {
        /* preventDefault only; NO stopPropagation here so analytics
           listeners (GA4 view_cart_dismissed etc.) can still observe. */
        e.preventDefault();
        var $ = window.jQuery;
        if ($) { $('body').removeClass('cart-sidebar-show'); }
        else { document.body.classList.remove('cart-sidebar-show'); }
        return;
      }
    }, /* useCapture */ false);
  }

  function wireSidebarActions(/* wrapper */) {
    installSidebarDelegation();  /* idempotent — only attaches on first call */
    populateInventoryCache();
    updatePlusButtonStates();
  }

  var _lastRenderedCart = null;
  function renderSidebarContent(cart, skipInvFetch) {
    updateCartQtyMap(cart);  /* Keep Quick-Shop inventory math in sync with every render */
    _lastRenderedCart = cart;
    ensureCartStyles();
    var wrapper = document.querySelector('.previewCart-wrapper');
    if (!wrapper) return;
    wrapper.innerHTML = renderSidebarShell(cart);
    wireSidebarActions(wrapper);
    /* Skip the /products/{handle}.js inventory fan-out on the initial background
       paint (sidebar not open yet) — it's fetched lazily on first real open. */
    if (!skipInvFetch) fetchInventoryForCart(cart);
  }

  function updateCartBadges(cart) {
    document.querySelectorAll(
      '[data-cart-count], .cart-count, .cart-count-bubble, .cartCount, [data-cart-item-count]'
    ).forEach(function (el) {
      var textSpan = el.querySelector('.text, [data-cart-count]');
      if (textSpan && textSpan !== el) {
        textSpan.textContent = cart.item_count;
      } else {
        el.textContent = cart.item_count;
      }
    });
    document.querySelectorAll('[data-cart-text]').forEach(function (el) {
      el.textContent = cart.item_count === 1 ? 'item' : 'items';
    });
  }

  function openSidebar() {
    /* If the Quick-Shop modal is still showing (post-add-to-cart, before its
       auto-close timer fires), hide it immediately so its z-index:10000
       backdrop doesn't intercept clicks on the sidebar (delete X, qty +/−).
       We set a flag the modal's own closeModal() honors to skip resetting
       document.body.style.overflow — the sidebar's cart-sidebar-show CSS
       class is about to manage overflow itself.
       closeModal lives in a different IIFE scope, so we duplicate its hide
       side-effects here (set hidden + clear _triggerBtn). The pending 300ms
       auto-close timer may still fire and call closeModal(), which is fine —
       the flag makes it idempotent and prevents the overflow clobber. */
    var qaModal = document.getElementById('v3-qa-modal');
    if (qaModal && !qaModal.hasAttribute('hidden')) {
      qaModal._closingForSidebar = true;
      qaModal.setAttribute('hidden', '');
      if (qaModal._triggerBtn) qaModal._triggerBtn = null;
      /* Release the modal's inline scroll lock as part of the handover. The
         sidebar's own lock (body.cart-sidebar-show class, set just below) is
         independent of this inline style, so clearing it here does NOT restore
         page scroll while the sidebar is open — it only prevents the inline
         lock from stranding if closeModal()'s auto-close timer never fires. */
      document.body.style.overflow = '';
    }

    var $ = window.jQuery;
    if ($) {
      $('body').addClass('cart-sidebar-show');
      $(document).trigger('cart.requestComplete');
      $(document.body).trigger('cart.requestComplete');
    } else {
      document.body.classList.add('cart-sidebar-show');
    }

    /* Sidebar is now visible — lazily fetch inventory for its items (the initial
       background paint skips this to avoid /products/*.js on every page load). */
    if (_lastRenderedCart) {
      fetchInventoryForCart(_lastRenderedCart);
      updatePlusButtonStates();
    }
  }

  function closeSidebar() {
    var $ = window.jQuery;
    if ($) { $('body').removeClass('cart-sidebar-show'); }
    else { document.body.classList.remove('cart-sidebar-show'); }
    /* Defensive, idempotent: guarantee the page is scrollable after the sidebar
       closes, no matter how the Quick-Shop modal that preceded it was dismissed.
       Removing cart-sidebar-show already lifts the class-based lock; this also
       clears any inline lock the modal may have left behind. Harmless no-op when
       inline overflow is already ''. */
    document.body.style.overflow = '';
  }

  var _refreshInFlight = null;  /* { seq, promise } */
  function refresh() {
    /* Coalesce concurrent refreshes into ONE /cart.js (429 mitigation) — but
       ONLY while no mutation has landed since that GET started. A shared
       in-flight promise from before a mutation is a stale snapshot: rendering
       it resurrects removed lines / hides just-added ones. */
    if (_refreshInFlight && _refreshInFlight.seq === _cartMutSeq) {
      return _refreshInFlight.promise;
    }
    var mySeq = _cartMutSeq;
    var p = fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        /* Reject cleanly on 429/5xx so callers hit .catch (open sidebar
           optimistically) instead of rendering a non-cart error body. */
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (mySeq !== _cartMutSeq) {
          /* A mutation completed while this GET was in flight → this snapshot
             is stale. Do NOT render it. Re-fetch once to converge (the
             mutation's own response already rendered, so this is just a
             consistency pass). */
          if (_refreshInFlight && _refreshInFlight.promise === p) _refreshInFlight = null;
          return refresh();
        }
        updateCartQtyMap(cart);  /* Authoritative server values overwrite any optimistic estimates */
        updateCartBadges(cart);
        renderSidebarContent(cart);
        if (typeof window.essentialInitCartBanners === 'function') {
          try { window.essentialInitCartBanners(); } catch (e) { /* noop */ }
        }
        return cart;
      })
      .finally(function () {
        if (_refreshInFlight && _refreshInFlight.promise === p) _refreshInFlight = null;
      });
    _refreshInFlight = { seq: mySeq, promise: p };
    return p;
  }

  window.v3Cart = {
    render: renderSidebarContent,
    updateBadges: updateCartBadges,
    open: openSidebar,
    close: closeSidebar,
    refresh: refresh,
    /* Call after ANY successful cart mutation done OUTSIDE this module
       (e.g. the /cart/add.js in pd-product-cta.liquid and
       pd-complete-bedroom.liquid), BEFORE calling refresh(). It invalidates
       any in-flight /cart.js snapshot so the sidebar can't be repainted
       with pre-mutation data. */
    noteMutation: noteCartMutation
  };

  /* bfcache restore guard: when the page is restored from the back-forward
     cache (event.persisted === true), any scroll lock that was active at
     navigation time comes back frozen in — a modal/sidebar the user left open,
     then navigated away from and back to. Do a one-shot TOTAL unlock (both the
     class-based sidebar lock AND the inline modal lock) so the restored page is
     never stuck. Idempotent and harmless on a normal, unlocked restore. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var $ = window.jQuery;
    if ($) { $('body').removeClass('cart-sidebar-show'); }
    else { document.body.classList.remove('cart-sidebar-show'); }
    document.body.style.overflow = '';
  });

  /* Seed the sidebar from server-rendered cart JSON at DOM-ready — NO /cart.js
     on page load (that fired on every page site-wide and was a major source of
     429 throttling). theme.js halo.updateSidebarCart is patched to delegate to
     v3Cart, so all internal call sites render V3. Every real cart action (add /
     qty change) still fetches authoritative data. */
  function initPrepaint() {
    try {
      var el = document.getElementById('v3-cart-bootstrap');
      if (el && el.textContent) {
        var cart = JSON.parse(el.textContent);
        updateCartQtyMap(cart);
        updateCartBadges(cart);
        renderSidebarContent(cart, /* skipInvFetch */ true);
        return;
      }
    } catch (e) { /* fall through — first sidebar open will render */ }
    /* Fallback only if the bootstrap blob is missing. */
    refresh().catch(function () { /* silent */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrepaint);
  } else {
    initPrepaint();
  }
})();

   (function () {
    'use strict';
  
    /* ----------------------------------------------------------
       1. SCROLL REVEAL
    ---------------------------------------------------------- */
    function initReveal() {
      var els = document.querySelectorAll('.v3-reveal');
      if (!els.length) return;
  
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('v3-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
  
      els.forEach(function (el) { observer.observe(el); });
    }
  
    /* ----------------------------------------------------------
       2. PRODUCT TAB SWITCHING
    ---------------------------------------------------------- */
    function initProductTabs() {
      var sections = document.querySelectorAll('.v3-product-tabs');
      sections.forEach(function (section) {
        var tabs = section.querySelectorAll('.v3-tab');
        var panels = section.querySelectorAll('.v3-panel');
  
        function activateTab(index) {
          tabs.forEach(function (t) {
            t.classList.remove('v3-tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) { p.classList.remove('v3-panel--active'); });
          tabs[index].classList.add('v3-tab--active');
          tabs[index].setAttribute('aria-selected', 'true');
          if (panels[index]) panels[index].classList.add('v3-panel--active');
        }
  
        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { activateTab(i); });
          tab.addEventListener('keydown', function (e) {
            var count = tabs.length;
            if (e.key === 'ArrowRight') { e.preventDefault(); activateTab((i + 1) % count); tabs[(i + 1) % count].focus(); }
            if (e.key === 'ArrowLeft')  { e.preventDefault(); activateTab((i - 1 + count) % count); tabs[(i - 1 + count) % count].focus(); }
            if (e.key === 'Home') { e.preventDefault(); activateTab(0); tabs[0].focus(); }
            if (e.key === 'End')  { e.preventDefault(); activateTab(count - 1); tabs[count - 1].focus(); }
          });
        });
      });
    }
  
    /* ----------------------------------------------------------
       3. COLOR SWATCH SELECTION
    ---------------------------------------------------------- */
    function initSwatches() {
      document.addEventListener('click', function (e) {
        var sw = e.target.closest('.v3-sw');
        if (!sw) return;
        var group = sw.closest('.v3-swatches');
        if (!group) return;
        group.querySelectorAll('.v3-sw').forEach(function (s) { s.classList.remove('v3-sw--active'); });
        sw.classList.add('v3-sw--active');
  
        /* Swap the card's featured image using data-img on the swatch */
        var card = sw.closest('.v3-pc');
        if (!card) return;
        var imgUrl = sw.dataset.img;
        if (!imgUrl) return;
        var img = card.querySelector('.v3-pc__img');
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = imgUrl;
      });
    }
  
    /* ----------------------------------------------------------
       4. QUICK SHOP MODAL
    ---------------------------------------------------------- */
    function initQuickAdd() {

      /* ── Body scroll lock/unlock ──
         openModal() locks page scroll with an inline body.style.overflow='hidden'.
         That inline lock MUST be released on EVERY modal-close path — X button,
         backdrop click, ESC, the post-add setTimeout, the sidebar handover, and
         ATC failure — or it strands and the whole page becomes unscrollable.
         Restoring is deliberately decoupled from "the modal is visually closing":
         the cart sidebar runs its OWN scroll lock via the body.cart-sidebar-show
         CSS class (component-quick-cart.css), which is independent of this inline
         style — so clearing inline here never restores scroll while the sidebar
         is open, and can be called unconditionally without racing the handover. */
      function unlockBodyScroll() {
        document.body.style.overflow = '';
      }

      /* ── CSS Injection ── */
      function injectStyles() {
        if (document.getElementById('v3-qs-styles')) return;
        var el = document.createElement('style');
        el.id = 'v3-qs-styles';
        el.textContent = [
          '#v3-qa-modal{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;}',
          '#v3-qa-modal[hidden]{display:none;}',
          '.v3-qs-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.5);cursor:pointer;}',
          '.v3-qs-wrap{position:relative;background:#fff;width:min(960px,96vw);height:min(680px,92vh);border-radius:4px;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.22);}',
          '.v3-qs-close{position:absolute;top:10px;right:12px;z-index:10;background:none;border:none;font-size:20px;cursor:pointer;color:#4a4a4a;width:36px;height:36px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background .2s;}',
          '.v3-qs-close:hover{background:#f0ede8;}',
          '.v3-qs-body{display:grid;grid-template-columns:45% 55%;height:100%;min-height:0;overflow:hidden;}',
          /* Gallery */
          '.v3-qs-gallery{display:flex;flex-direction:column;background:#f5f2ee;overflow:hidden;}',
          '.v3-qs-gl-stage{flex:1;overflow:hidden;position:relative;min-height:0;}',
          '.v3-qs-gl-track{display:flex;width:100%;height:100%;transition:transform .3s ease;will-change:transform;}',
          '.v3-qs-gl-slide{flex-shrink:0;width:100%;height:100%;}',
          '.v3-qs-gl-slide img{width:100%;height:100%;object-fit:cover;display:block;}',
          '.v3-qs-gl-arrow{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.92);border:none;width:36px;height:36px;border-radius:50%;cursor:pointer;font-size:22px;display:flex;align-items:center;justify-content:center;z-index:2;box-shadow:0 2px 8px rgba(0,0,0,.15);color:#364e41;transition:background .2s;line-height:1;padding:0;}',
          '.v3-qs-gl-arrow:hover{background:#fff;}',
          '.v3-qs-gl-prev{left:8px;}',
          '.v3-qs-gl-next{right:8px;}',
          '.v3-qs-gl-thumbs{display:flex;gap:6px;padding:8px;overflow-x:auto;background:#ede9e3;flex-shrink:0;min-height:76px;align-items:center;scroll-behavior:smooth;}',
          '.v3-qs-gl-thumbs::-webkit-scrollbar{height:3px;}',
          '.v3-qs-gl-thumbs::-webkit-scrollbar-thumb{background:#d4cfc7;border-radius:2px;}',
          '.v3-qs-gl-thumb{width:60px;height:60px;flex-shrink:0;border:2px solid transparent;cursor:pointer;border-radius:2px;overflow:hidden;transition:border-color .2s;background:none;padding:0;}',
          '.v3-qs-gl-thumb:hover{border-color:#b8c4b8;}',
          '.v3-qs-gl-thumb.v3-qs-active{border-color:#364e41;}',
          '.v3-qs-gl-thumb img{width:100%;height:100%;object-fit:cover;display:block;}',
          /* Info */
          '.v3-qs-info{padding:24px 24px 0;overflow-y:auto;display:flex;flex-direction:column;gap:14px;}',
          '.v3-qs-title{font-family:var(--v3-font-d,"Gilda Display",Georgia,serif);font-size:24px;font-weight:400;color:#2a2a2a;margin:0;padding-right:24px;line-height:1.3;}',
          /* Includes 行（价格上方） */
          '.v3-qs-includes{font-size:13px;line-height:1.55;color:#4a4a4a;margin:-4px 0 0;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-includes[hidden]{display:none;}',
          '.v3-qs-price-row{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}',
          '.v3-qs-price-now{font-size:17px;font-weight:700;color:#364e41;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-price-was{font-size:13px;color:#7a7a7a;text-decoration:line-through;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-price-save{font-size:11px;color:#c75050;background:#f5e7e4;padding:2px 7px;font-family:var(--v3-font-b,sans-serif);}',
          /* Options */
          '.v3-qs-opt-group{display:flex;flex-direction:column;gap:8px;}',
          '.v3-qs-opt-head{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:#4a4a4a;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-opt-head .v3-qs-opt-name strong{font-weight:600;color:#2a2a2a;text-transform:none;letter-spacing:0;font-size:12px;margin-left:4px;}',
          '.v3-qs-size-guide{font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:#364e41;background:none;border:none;cursor:pointer;display:inline-flex;align-items:center;gap:2px;padding:0;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-size-guide:hover{text-decoration:underline;}',
          '.v3-qs-size-guide svg{width:13px;height:13px;}',
          /* 颜色色板（单外圈 + ✓） */
          '.v3-qs-colors{display:flex;gap:16px;flex-wrap:wrap;}',
          '.v3-qs-color-item{display:flex;flex-direction:column;align-items:center;gap:6px;background:none;border:none;padding:0;cursor:pointer;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-swatch{width:40px;height:40px;border-radius:50%;border:2px solid #e8e0d6;overflow:hidden;transition:border-color .2s;position:relative;display:flex;align-items:center;justify-content:center;background-size:cover;background-position:center;}',
          '.v3-qs-swatch img{width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;}',
          '.v3-qs-swatch .v3-qs-check{position:absolute;width:16px;height:16px;color:#fff;display:none;z-index:1;filter:drop-shadow(0 0 2px rgba(0,0,0,.45));}',
          '.v3-qs-color-item.v3-qs-active .v3-qs-swatch{border-color:#364e41;}',
          '.v3-qs-color-item.v3-qs-active .v3-qs-check{display:block;}',
          '.v3-qs-color-name{font-size:12px;color:#6a6a6a;text-transform:none;letter-spacing:0;font-weight:400;}',
          /* 尺码按钮 */
          '.v3-qs-sizes{display:flex;gap:8px;flex-wrap:wrap;}',
          '.v3-qs-sz{min-width:60px;height:40px;padding:0 16px;border:1.5px solid #e8e0d6;border-radius:8px;font-size:14px;cursor:pointer;background:#fff;color:#2a2a2a;font-family:var(--v3-font-b,sans-serif);display:flex;align-items:center;justify-content:center;transition:all .15s;}',
          '.v3-qs-sz:hover:not(.v3-qs-sz--active){border-color:#364e41;}',
          '.v3-qs-sz--active{border-color:#364e41;background:#364e41;color:#fff;}',
          '.v3-qs-sz--unavail{opacity:.38;cursor:not-allowed;text-decoration:line-through;}',
          /* Quantity（标签在上，右侧显示 Only N left!） */
          '.v3-qs-qty-section{display:flex;flex-direction:column;gap:8px;}',
          '.v3-qs-qty-lbl{font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:#4a4a4a;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-qty-row{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;}',
          '.v3-qs-qty-ctrl{display:inline-flex;align-items:center;border:1.5px solid #e8e0d6;border-radius:8px;overflow:hidden;background:#fff;width:max-content;}',
          '.v3-qs-qty-btn{width:44px;height:44px;border:none;background:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#2a2a2a;flex-shrink:0;}',
          '.v3-qs-qty-btn:hover{background:#f5f2ee;}',
          '.v3-qs-qty-btn svg{width:14px;height:14px;}',
          '.v3-qs-qty-input{width:44px;height:44px;border:none;background:#faf8f5;text-align:center;font-size:15px;font-weight:600;color:#2a2a2a;outline:none;font-family:var(--v3-font-b,sans-serif);-moz-appearance:textfield;appearance:textfield;}',
          '.v3-qs-qty-input::-webkit-outer-spin-button,.v3-qs-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none;margin:0;}',
          '.v3-qs-urgency{font-size:14px;font-weight:600;color:#c75050;display:inline-flex;align-items:center;gap:7px;letter-spacing:0;text-transform:none;margin-left:auto;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-urgency[hidden]{display:none;}',
          '.v3-qs-urgency-dot{width:8px;height:8px;border-radius:50%;background:#c75050;display:inline-block;animation:v3qsPulse 1.5s ease-in-out infinite;}',
          '@keyframes v3qsPulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.5;transform:scale(1.25);}}',
          /* Submit */
          '.v3-qa-submit{width:100%;height:48px;background:#354637!important;color:#fff!important;border:none;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-family:var(--v3-font-b,sans-serif);cursor:pointer;transition:opacity .2s;border-radius:4px;flex-shrink:0;}',
          '.v3-qa-submit:hover:not(.v3-qa--busy):not(.v3-qa--sold-out){opacity:.88;}',
          '.v3-qa-submit.v3-qa--busy{opacity:.82;pointer-events:none;cursor:default;}',
          '.v3-qa-submit.v3-qa--sold-out{background:rgba(74,74,74,.55)!important;cursor:default;}',
          '.v3-qa-msg{font-size:12px;margin:0;min-height:0;font-family:var(--v3-font-b,sans-serif);}',
          /* Accordions */
          '.v3-qs-accordions{border-top:1px solid #e8e0d6;flex-shrink:0;}',
          '.v3-qs-acc-item{border-bottom:1px solid #e8e0d6;}',
          '.v3-qs-acc-trigger{width:100%;background:none;border:none;padding:12px 0;display:flex;justify-content:space-between;align-items:center;cursor:pointer;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:#2a2a2a;font-family:var(--v3-font-b,sans-serif);text-align:left;}',
          '.v3-qs-acc-trigger:hover{color:#364e41;}',
          '.v3-qs-acc-chevron{width:15px;height:15px;transition:transform .3s;flex-shrink:0;color:#4a4a4a;}',
          '.v3-qs-acc-trigger.v3-qs-open .v3-qs-acc-chevron{transform:rotate(180deg);}',
          '.v3-qs-acc-body{max-height:0;overflow:hidden;transition:max-height .35s ease;}',
          '.v3-qs-acc-body.v3-qs-open{max-height:1200px;}',
          '.v3-qs-acc-body-inner{padding:0 0 18px;font-size:13px;line-height:1.7;color:#4a4a4a;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-acc-body-inner p{margin:0 0 12px;}.v3-qs-acc-body-inner p:last-child{margin-bottom:0;}',
          '.v3-qs-acc-body-inner ul{margin:0 0 12px;padding-left:18px;list-style:disc;}',
          '.v3-qs-acc-body-inner li{margin-bottom:6px;}',
          '.v3-qs-acc-body-inner a{color:#2a2a2a;text-decoration:underline;text-underline-offset:2px;}',
          '.v3-qs-acc-body-inner a:hover{color:#364e41;}',
          '.v3-qs-acc-body-inner strong{color:#2a2a2a;font-weight:600;}',
          '.v3-qs-acc-body-inner h5{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#2a2a2a;margin:14px 0 6px;}',
          '.v3-qs-acc-body-inner h5:first-child{margin-top:0;}',
          /* Full details link（去掉 border-top，字号 13px） */
          '.v3-qs-full-link{display:block;text-align:center;padding:16px 0 20px;font-size:13px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#364e41;text-decoration:none;font-family:var(--v3-font-b,sans-serif);margin-top:0;transition:opacity .2s;flex-shrink:0;}',
          '.v3-qs-full-link:hover{opacity:.7;}',
          /* Size Guide 内嵌弹窗 */
          '#v3-qs-sg-modal{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:10010;align-items:flex-start;justify-content:center;padding:40px 16px;overflow-y:auto;}',
          '#v3-qs-sg-modal.v3-qs-open{display:flex;}',
          '.v3-qs-sg-box{background:#fff;border-radius:16px;padding:24px;width:100%;max-width:560px;position:relative;margin:auto 0;}',
          '.v3-qs-sg-hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}',
          '.v3-qs-sg-ttl{font-family:var(--v3-font-d,"Gilda Display",Georgia,serif);font-size:18px;font-weight:400;color:#2a2a2a;}',
          '.v3-qs-sg-cls{width:32px;height:32px;background:none;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6a6a6a;border-radius:50%;transition:background .15s;}',
          '.v3-qs-sg-cls:hover{background:#f5f5f5;}',
          '.v3-qs-sg-cls svg{width:18px;height:18px;}',
          '.v3-qs-sg-sub{font-size:14px;color:#6a6a6a;line-height:1.6;margin:0 0 16px;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-sg-note{font-size:13px;color:#6a6a6a;background:#faf8f5;border-radius:6px;padding:10px 14px;margin-bottom:16px;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-sg-img{width:100%;border-radius:8px;display:block;margin-bottom:16px;}',
          '.v3-qs-sg-cnt{font-size:14px;color:#6a6a6a;line-height:1.7;font-family:var(--v3-font-b,sans-serif);}',
          '.v3-qs-sg-cnt table{width:100%;border-collapse:collapse;font-size:13px;}',
          '.v3-qs-sg-cnt th,.v3-qs-sg-cnt td{border:1px solid #e8e4dd;padding:8px 12px;text-align:left;}',
          '.v3-qs-sg-cnt th{background:#faf8f5;font-weight:500;color:#2a2a2a;}',
          /* Responsive */
          '@media(max-width:680px){',
          '.v3-qs-wrap{width:100vw;height:100dvh;max-height:100dvh;border-radius:0;}',
          '.v3-qs-body{grid-template-columns:1fr;overflow-y:auto;height:auto;}',
          '.v3-qs-gallery{height:auto;flex-shrink:0;}',
          '.v3-qs-gl-stage{aspect-ratio:4/3;flex:none;}',
          '.v3-qs-gl-thumbs{min-height:auto;padding:6px 8px;gap:4px;}',
          '.v3-qs-gl-thumb{width:44px;height:44px;}',
          '.v3-qs-info{padding:18px 18px 0;}',
          '.v3-qs-title{font-size:22px;}',
          '}'
        ].join('');
        document.head.appendChild(el);
      }
  
      /* ── Money formatter ── */
      function fmt(cents) {
        // 只有当 Shopify.formatMoney 和 Shopify.money_format 都存在时才用主题格式化
        // （有些主题在某些页面没注入 money_format，会导致内部 .match() 崩溃）
        try {
          if (window.Shopify && typeof Shopify.formatMoney === 'function'
              && typeof Shopify.money_format === 'string' && Shopify.money_format) {
            return Shopify.formatMoney(cents, Shopify.money_format);
          }
        } catch (e) { /* fallthrough to local format */ }
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
  
      /* ── Gallery helpers ── */
      function buildGallery(m, images) {
        var track     = m.querySelector('.v3-qs-gl-track');
        var thumbsWrap = m.querySelector('.v3-qs-gl-thumbs');
        track.innerHTML = '';
        thumbsWrap.innerHTML = '';
        m._glIndex = 0;
        m._glTotal = images.length;
  
        images.forEach(function (img, i) {
          var slide = document.createElement('div');
          slide.className = 'v3-qs-gl-slide';
          var image = document.createElement('img');
          image.src = img.src;
          image.alt = img.alt || '';
          image.loading = i === 0 ? 'eager' : 'lazy';
          slide.appendChild(image);
          track.appendChild(slide);
  
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'v3-qs-gl-thumb' + (i === 0 ? ' v3-qs-active' : '');
          thumb.setAttribute('aria-label', 'Image ' + (i + 1));
          var tImg = document.createElement('img');
          tImg.src = img.thumb;
          tImg.alt = '';
          tImg.loading = 'lazy';
          thumb.appendChild(tImg);
          thumb.addEventListener('click', function () { goToSlide(m, i); });
          thumbsWrap.appendChild(thumb);
        });
  
        updateArrows(m);
        m.querySelector('.v3-qs-gl-prev').onclick = function () { goToSlide(m, m._glIndex - 1); };
        m.querySelector('.v3-qs-gl-next').onclick = function () { goToSlide(m, m._glIndex + 1); };
      }
  
      function goToSlide(m, index) {
        var total = m._glTotal || 0;
        if (total <= 1) return;
        index = Math.max(0, Math.min(total - 1, index));
        m._glIndex = index;
        var track = m.querySelector('.v3-qs-gl-track');
        if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
        var activeThumb = null;
        m.querySelectorAll('.v3-qs-gl-thumb').forEach(function (t, i) {
          var on = (i === index);
          t.classList.toggle('v3-qs-active', on);
          if (on) activeThumb = t;
        });
        if (activeThumb && activeThumb.scrollIntoView) {
          try { activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
        }
        updateArrows(m);
      }
  
      function updateArrows(m) {
        var prev  = m.querySelector('.v3-qs-gl-prev');
        var next  = m.querySelector('.v3-qs-gl-next');
        var total = m._glTotal || 0;
        if (prev) prev.style.visibility = (total <= 1 || m._glIndex === 0) ? 'hidden' : 'visible';
        if (next) next.style.visibility = (total <= 1 || m._glIndex >= total - 1) ? 'hidden' : 'visible';
      }
  
      /* 标准化 Shopify CDN 图片 URL：去掉 ?v=xxx 查询、去掉 _500x500 尺寸后缀 */
      function normImgUrl(u) {
        if (!u) return '';
        u = String(u).split('?')[0];
        /* 协议相对 URL 补齐 */
        if (u.indexOf('//') === 0) u = 'https:' + u;
        /* 去掉 _\d+x\d* 尺寸后缀 */
        u = u.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)(?=\.[a-zA-Z]+(?:$|\?))/, '');
        return u;
      }

      /* 按 image id（优先）或 src URL（标准化后）在 product.images 里找 index，找不到返回 -1 */
      function findSlideIndex(product, imgId, imgSrc) {
        if (!product.images || !product.images.length) return -1;
        if (imgId != null) {
          for (var i = 0; i < product.images.length; i++) {
            if (product.images[i].id === imgId) return i;
          }
        }
        if (imgSrc) {
          var target = normImgUrl(imgSrc);
          for (var j = 0; j < product.images.length; j++) {
            if (normImgUrl(product.images[j].src)  === target) return j;
            if (normImgUrl(product.images[j].thumb) === target) return j;
          }
        }
        return -1;
      }

      /* Show a transient message in the Quick-Shop modal's .v3-qa-msg area.
         If isError + telemetry is provided, also push a dataLayer event so
         GA4 / Tag Manager can distinguish "校验正确拦截了过量加购" from
         "校验误杀了正常购买". telemetry shape:
           { source, variantId, productId, attemptedQty, remainingAddable, inCartQty } */
      function showQuickShopMsg(m, text, isError, telemetry) {
        var msgEl = m.querySelector('.v3-qa-msg');
        if (!msgEl) return;
        msgEl.textContent = text || '';
        msgEl.style.color = isError ? '#c75050' : '';
        if (text) {
          clearTimeout(msgEl._fadeTimer);
          msgEl._fadeTimer = setTimeout(function () {
            if (msgEl.textContent === text) msgEl.textContent = '';
          }, 2500);
        }
        if (isError && telemetry) {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'v3_inventory_cap_triggered',
              source: telemetry.source,
              variant_id: telemetry.variantId,
              product_id: telemetry.productId,
              attempted_qty: telemetry.attemptedQty,
              remaining_addable: telemetry.remainingAddable,
              in_cart_qty: telemetry.inCartQty
            });
          } catch (e) { /* noop */ }
        }
      }

      /* ── Build modal DOM once ── */
      function getModal() {
        var existing = document.getElementById('v3-qa-modal');
        if (existing) return existing;
  
        injectStyles();
  
        var m = document.createElement('div');
        m.id = 'v3-qa-modal';
        m.setAttribute('role', 'dialog');
        m.setAttribute('aria-modal', 'true');
        m.setAttribute('aria-labelledby', 'v3-qs-title');
        m.setAttribute('hidden', '');
        m.innerHTML =
          '<div class="v3-qs-backdrop"></div>' +
          '<div class="v3-qs-wrap">' +
            '<button class="v3-qs-close" aria-label="Close">&#x2715;</button>' +
            '<div class="v3-qs-body">' +
              '<div class="v3-qs-gallery">' +
                '<div class="v3-qs-gl-stage">' +
                  '<div class="v3-qs-gl-track"></div>' +
                  '<button class="v3-qs-gl-arrow v3-qs-gl-prev" type="button" aria-label="Previous">&#8249;</button>' +
                  '<button class="v3-qs-gl-arrow v3-qs-gl-next" type="button" aria-label="Next">&#8250;</button>' +
                '</div>' +
                '<div class="v3-qs-gl-thumbs"></div>' +
              '</div>' +
              '<div class="v3-qs-info">' +
                '<h2 class="v3-qs-title" id="v3-qs-title"></h2>' +
                '<p class="v3-qs-includes" hidden></p>' +
                '<div class="v3-qs-price-row">' +
                  '<span class="v3-qs-price-now"></span>' +
                  '<span class="v3-qs-price-was"></span>' +
                  '<span class="v3-qs-price-save"></span>' +
                '</div>' +
                '<div class="v3-qs-options-color"></div>' +
                '<div class="v3-qs-options-size"></div>' +
                '<div class="v3-qs-options-other"></div>' +
                '<div class="v3-qs-qty-section">' +
                  '<div class="v3-qs-qty-lbl">Quantity</div>' +
                  '<div class="v3-qs-qty-row">' +
                    '<div class="v3-qs-qty-ctrl">' +
                      '<button class="v3-qs-qty-btn v3-qs-qty-minus" type="button" aria-label="Decrease">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                      '</button>' +
                      '<input class="v3-qs-qty-input" type="text" inputmode="numeric" pattern="[0-9]*" value="1" aria-label="Quantity">' +
                      '<button class="v3-qs-qty-btn v3-qs-qty-plus" type="button" aria-label="Increase">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                      '</button>' +
                    '</div>' +
                    '<span class="v3-qs-urgency" hidden><span class="v3-qs-urgency-dot"></span><span class="v3-qs-urgency-text"></span></span>' +
                  '</div>' +
                '</div>' +
                '<button class="v3-qa-submit" type="button">Add to Cart</button>' +
                '<p class="v3-qa-msg" aria-live="polite"></p>' +
                '<div class="v3-qs-accordions"></div>' +
                '<a class="v3-qs-full-link" href="#" target="_self">View Full Details &#8594;</a>' +
              '</div>' +
            '</div>' +
            /* Size Guide 内嵌弹窗 */
            '<div id="v3-qs-sg-modal" role="dialog" aria-modal="true" aria-labelledby="v3-qs-sg-ttl">' +
              '<div class="v3-qs-sg-box">' +
                '<div class="v3-qs-sg-hd">' +
                  '<span class="v3-qs-sg-ttl" id="v3-qs-sg-ttl">Size Guide</span>' +
                  '<button type="button" class="v3-qs-sg-cls" aria-label="Close">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
                  '</button>' +
                '</div>' +
                '<p class="v3-qs-sg-sub" hidden></p>' +
                '<img class="v3-qs-sg-img" alt="" hidden>' +
                '<p class="v3-qs-sg-note" hidden></p>' +
                '<div class="v3-qs-sg-cnt"></div>' +
              '</div>' +
            '</div>' +
          '</div>';
        document.body.appendChild(m);
  
        /* Close handlers */
        m.querySelector('.v3-qs-backdrop').addEventListener('click', closeModal);
        m.querySelector('.v3-qs-close').addEventListener('click', closeModal);
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          var sg = document.getElementById('v3-qs-sg-modal');
          if (sg && sg.classList.contains('v3-qs-open')) {
            sg.classList.remove('v3-qs-open');
            return;
          }
          var mo = document.getElementById('v3-qa-modal');
          if (mo && !mo.hasAttribute('hidden')) closeModal();
        });

        /* Size Guide 弹窗关闭处理 */
        var sgModal = m.querySelector('#v3-qs-sg-modal');
        if (sgModal) {
          sgModal.addEventListener('click', function (e) {
            if (e.target === sgModal || e.target.closest('.v3-qs-sg-cls')) {
              sgModal.classList.remove('v3-qs-open');
            }
          });
        }
  
        /* Quantity handlers — inventory-aware caps (改动 G/H).
           Each handler reads the CURRENT variantId from the submit button
           (kept in sync by syncVariant) and computes remaining-addable as
           total_inventory − already_in_cart for that variant.
           window.V3_INVENTORY_GUARDS_DISABLED is a runtime kill switch that
           falls back to the legacy hardcoded-99 cap if the new logic ever
           false-positives a legitimate purchase. */
        var qtyInput = m.querySelector('.v3-qs-qty-input');
        m.querySelector('.v3-qs-qty-minus').addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        });
        m.querySelector('.v3-qs-qty-plus').addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (window.V3_INVENTORY_GUARDS_DISABLED) {
            if (v < 99) qtyInput.value = v + 1;
            return;
          }
          var variantId = m.querySelector('.v3-qa-submit').dataset.variantId;
          var remaining = (typeof window.v3GetRemainingAddable === 'function')
            ? window.v3GetRemainingAddable(variantId)
            : 99999;
          var cap = (remaining >= 99999) ? 99 : remaining;
          if (v < cap) {
            qtyInput.value = v + 1;
            showQuickShopMsg(m, '', false);
          } else {
            showQuickShopMsg(m,
              remaining <= 0 ? 'Maximum available is already in your cart'
                             : 'Only ' + remaining + ' more available',
              true,
              {
                source: 'plus_button',
                variantId: variantId,
                productId: m._currentProduct ? m._currentProduct.id : null,
                attemptedQty: v + 1,
                remainingAddable: remaining,
                inCartQty: window.v3CartItemQtyByVariant[variantId] || 0
              });
          }
        });
        qtyInput.addEventListener('change', function () {
          var v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 1) { qtyInput.value = 1; return; }
          if (window.V3_INVENTORY_GUARDS_DISABLED) {
            if (v > 99) qtyInput.value = 99;
            return;
          }
          var variantId = m.querySelector('.v3-qa-submit').dataset.variantId;
          var remaining = (typeof window.v3GetRemainingAddable === 'function')
            ? window.v3GetRemainingAddable(variantId)
            : 99999;
          var cap = (remaining >= 99999) ? 99 : remaining;
          if (v > cap) {
            qtyInput.value = Math.max(1, cap);
            showQuickShopMsg(m,
              remaining <= 0 ? 'Maximum available is already in your cart'
                             : 'Only ' + remaining + ' more available',
              true,
              {
                source: 'qty_input_change',
                variantId: variantId,
                productId: m._currentProduct ? m._currentProduct.id : null,
                attemptedQty: v,
                remainingAddable: remaining,
                inCartQty: window.v3CartItemQtyByVariant[variantId] || 0
              });
          } else {
            showQuickShopMsg(m, '', false);
          }
        });
  
        /* Add to cart */
        m.querySelector('.v3-qa-submit').addEventListener('click', function () {
          var btn = this;
          var variantId = btn.dataset.variantId;
          if (!variantId || btn.classList.contains('v3-qa--busy') || btn.classList.contains('v3-qa--sold-out')) return;
          var qty = parseInt(m.querySelector('.v3-qs-qty-input').value, 10) || 1;

          /* ── Inventory pre-flight (改动 I-1) ────────────────────────────
             Block the submission if (qty + already-in-cart) > inventory.
             Skip entirely when window.V3_INVENTORY_GUARDS_DISABLED is set
             (runtime kill switch) or when inventory is unknown (99999).
             For unknown inventory, /cart/add.js will still surface server-side
             errors via the existing .catch path. */
          if (!window.V3_INVENTORY_GUARDS_DISABLED) {
            var remaining = (typeof window.v3GetRemainingAddable === 'function')
              ? window.v3GetRemainingAddable(variantId)
              : 99999;
            if (remaining < 99999) {
              if (remaining <= 0) {
                showQuickShopMsg(m, 'Maximum available is already in your cart', true, {
                  source: 'submit_handler',
                  variantId: variantId,
                  productId: m._currentProduct ? m._currentProduct.id : null,
                  attemptedQty: qty,
                  remainingAddable: 0,
                  inCartQty: window.v3CartItemQtyByVariant[variantId] || 0
                });
                return;
              }
              if (qty > remaining) {
                m.querySelector('.v3-qs-qty-input').value = remaining;
                showQuickShopMsg(m, 'Only ' + remaining + ' more available — quantity adjusted', true, {
                  source: 'submit_handler',
                  variantId: variantId,
                  productId: m._currentProduct ? m._currentProduct.id : null,
                  attemptedQty: qty,
                  remainingAddable: remaining,
                  inCartQty: window.v3CartItemQtyByVariant[variantId] || 0
                });
                return;
              }
            }
          }

          var msgEl = m.querySelector('.v3-qa-msg');
          if (msgEl) msgEl.textContent = '';

          /* Cancel any pending close-modal timeout from a previous add.
             If user opens modal again within 1.5s of a prior success, the stale
             timeout would otherwise strip busy + close modal mid-add.
             The pending timer's callback is also what restores the scroll lock
             (via closeModal). If a close was already committed (modal hidden)
             but that timer hasn't fired yet, cancelling it here would strand the
             inline lock — so unlock first in that case. When the modal is still
             visible we're reusing it, and it stays locked. */
          if (btn._closeTimeout) {
            if (m.hasAttribute('hidden')) unlockBodyScroll();
            clearTimeout(btn._closeTimeout);
            btn._closeTimeout = null;
          }

          btn.classList.add('v3-qa--busy');
          btn.textContent = 'Adding...';

          /* ── Optimistic cart-qty update (改动 I-2) ─────────────────────
             Bump the local cart-qty cache BEFORE /cart/add.js completes.
             This closes the race window where a rapid double-click could
             pass pre-flight twice (reading stale in_cart=0 both times)
             and end up adding 2× the allowed quantity. refresh() will
             overwrite with authoritative server values shortly after.
             On error, the .catch below rolls this increment back. */
          if (!window.V3_INVENTORY_GUARDS_DISABLED) {
            window.v3CartItemQtyByVariant[variantId] =
              (window.v3CartItemQtyByVariant[variantId] || 0) + qty;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
          })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + r.status); });
            return r.json();
          })
          .then(function () {
            btn.textContent = 'Added!';
            if (window.v3Cart && window.v3Cart.noteMutation) window.v3Cart.noteMutation();

            /* Render + open the V3 sidebar via the shared module.
               All other callers (PDP, collection quick-add, etc.)
               go through theme.js halo.updateSidebarCart, which is
               patched to delegate here too. */
            if (window.v3Cart) {
              window.v3Cart.refresh().then(function () {
                var qc = window.quick_cart || {};
                if (qc.show !== false) window.v3Cart.open();
              }).catch(function (e) {
                if (window.console) console.warn('[V3] cart refresh failed', e);
              });
            }

            btn._closeTimeout = setTimeout(function () {
              btn._closeTimeout = null;
              btn.classList.remove('v3-qa--busy');
              btn.textContent = 'Add to Cart';
              closeModal();
            }, 300);
          })
          .catch(function (err) {
            /* Roll back the optimistic increment so the user can retry. */
            if (!window.V3_INVENTORY_GUARDS_DISABLED) {
              window.v3CartItemQtyByVariant[variantId] =
                Math.max(0, (window.v3CartItemQtyByVariant[variantId] || 0) - qty);
            }
            btn.classList.remove('v3-qa--busy');
            btn.textContent = 'Add to Cart';
            /* Defensive: a failed/429 add takes NO close path (the modal stays
               open for retry) and schedules NO restore timer, so the inline lock
               would otherwise depend solely on a later manual close. Release it
               here so a failure can never strand the page scroll. */
            unlockBodyScroll();

            /* Surface Shopify's actual error so users understand what happened
               (e.g. "All 1 of [variant] are in your cart" / "Cannot find variant"). */
            var errMsg = '';
            if (err) {
              if (typeof err === 'string') {
                errMsg = err;
              } else if (err.description) {
                errMsg = err.description;
              } else if (err.message && err.message !== '[object Object]') {
                errMsg = err.message;
              } else if (err.errors) {
                errMsg = (typeof err.errors === 'string') ? err.errors : JSON.stringify(err.errors);
              }
            }
            if (msgEl) {
              msgEl.textContent = errMsg || 'Failed to add. Please try again.';
              msgEl.style.color = '#c75050';
            }
            if (window.console) console.error('[V3 QuickAdd] Add to cart failed:', err);
          });
        });
  
        return m;
      }
  
      /* ── Close modal ── */
      function closeModal() {
        var m = document.getElementById('v3-qa-modal');
        if (!m) return;
        m.setAttribute('hidden', '');
        /* Release the inline scroll lock UNCONDITIONALLY on every close path,
           including the openSidebar() handover (_closingForSidebar). The cart
           sidebar manages its own lock via the body.cart-sidebar-show CSS class,
           which is independent of this inline style — so clearing inline here
           cannot restore scroll while the sidebar is open, but it does prevent
           the inline lock from stranding once the sidebar itself closes. */
        unlockBodyScroll();
        m._closingForSidebar = false; /* one-shot flag */
        if (m._triggerBtn) { m._triggerBtn.focus(); m._triggerBtn = null; }
      }
  
      /* ── Sync variant (price + button + gallery) ── */
      /* ── 找某个颜色的"第 1 张图"在当前 product.images 里的 index ── */
      function findColorFirstImageIndex(product, colorValue) {
        if (!colorValue || !product.variants || !product.images || !product.images.length) return -1;
        var colorIdx = product._colorOptIdx;
        if (colorIdx == null || colorIdx < 0) return -1;
        var optKey = 'option' + (colorIdx + 1);

        /* ① 用 featured_image.position 直接索引（最可靠：position 是 1-based，images 是 0-based） */
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          if (v[optKey] !== colorValue) continue;
          if (v.featured_image_position != null && v.featured_image_position > 0) {
            var posIdx = v.featured_image_position - 1;
            if (posIdx >= 0 && posIdx < product.images.length) return posIdx;
          }
        }

        /* ② fallback: 用 src URL 匹配 */
        for (var ii = 0; ii < product.variants.length; ii++) {
          var v2 = product.variants[ii];
          if (v2[optKey] !== colorValue) continue;
          if (v2.featured_image_src) {
            var idx = findSlideIndex(product, null, v2.featured_image_src);
            if (idx >= 0) return idx;
          }
        }

        /* ③ fallback: alt 文字匹配（图片 alt 里含颜色名） */
        var toHandle = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
        var ch = toHandle(colorValue);
        if (ch) {
          for (var k = 0; k < product.images.length; k++) {
            var imgAlt = toHandle(product.images[k].alt);
            if (imgAlt.indexOf(ch) >= 0) return k;
          }
        }
        return -1;
      }

      /* ── 更新 Only N left! 紧迫感提示 ── */
      function updateUrgency(m, product, variant) {
        var urgencyEl = m.querySelector('.v3-qs-urgency');
        if (!urgencyEl) return;
        var textEl = urgencyEl.querySelector('.v3-qs-urgency-text');
        var inv = (product._inv && variant) ? product._inv[variant.id] : undefined;
        var threshold = product._threshold || 5;
        var labels = product._labels || {};
        if (variant && variant.available && typeof inv === 'number' && inv > 0 && inv <= threshold) {
          var tpl = labels.only_n_left || 'Only [N] left!';
          if (textEl) textEl.textContent = tpl.replace('[N]', inv);
          urgencyEl.hidden = false;
        } else {
          urgencyEl.hidden = true;
        }
      }

      function syncVariant(m, product, selected, colorChangedValue) {
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var ok = true;
          for (var j = 0; j < product.options.length; j++) {
            var key = 'option' + product.options[j].position;
            if (v[key] !== selected[product.options[j].position]) { ok = false; break; }
          }
          if (ok) { variant = v; break; }
        }

        var submitBtn = m.querySelector('.v3-qa-submit');
        var priceNow  = m.querySelector('.v3-qs-price-now');
        var priceWas  = m.querySelector('.v3-qs-price-was');
        var priceSave = m.querySelector('.v3-qs-price-save');
        var labels = product._labels || {};

        if (!variant) {
          submitBtn.classList.add('v3-qa--sold-out');
          submitBtn.classList.remove('v3-qa--busy');
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = labels.unavailable || 'Unavailable';
          submitBtn.dataset.variantId = '';
          /* Clear cached references — Quick-Shop inventory checks bail out
             cleanly when m._currentVariant is null. */
          m._currentVariant = null;
          m._currentProduct = product;
          updateUrgency(m, product, null);
          return;
        }

        submitBtn.dataset.variantId = variant.id;
        /* Stash variant + product on the modal element so qty handlers and
           the submit handler can compute inventory limits without re-walking
           the option DOM. Read in the .v3-qs-qty-plus / change / submit
           handlers. */
        m._currentVariant = variant;
        m._currentProduct = product;
        /* Keep window.v3VariantInventory in sync with this variant so that
           both the Quick-Shop modal AND the sidebar's qty +/− buttons read
           the same authoritative inventory number. Three sources, in order:
             1. product._inv (collection-page meta JSON, pre-computed authoritative)
             2. Falsy inventory_management OR inventory_policy === 'continue'
                — unlimited (untracked or explicit oversell)
             3. Tracked + deny — use the variant's inventory_quantity field
           Falsy check on inventory_management catches both null AND "" which
           Shopify returns for different product-creation origins. */
        if (product._inv && (variant.id in product._inv)) {
          window.v3VariantInventory[variant.id] = product._inv[variant.id];
        } else if (!variant.inventory_management || variant.inventory_policy === 'continue') {
          window.v3VariantInventory[variant.id] = 99999;
        } else if (typeof variant.inventory_quantity === 'number') {
          window.v3VariantInventory[variant.id] = Math.max(0, variant.inventory_quantity);
        }
        submitBtn.classList.remove('v3-qa--busy');
        if (variant.available) {
          submitBtn.classList.remove('v3-qa--sold-out');
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = labels.add_to_cart || 'Add to Cart';
        } else {
          submitBtn.classList.add('v3-qa--sold-out');
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = labels.sold_out || 'Sold Out';
        }

        priceNow.textContent = fmt(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = fmt(variant.compare_at_price);
          priceSave.textContent = 'Save ' + fmt(variant.compare_at_price - variant.price);
          priceWas.style.display = '';
          priceSave.style.display = '';
        } else {
          priceWas.style.display = 'none';
          priceSave.style.display = 'none';
        }

        /* 库存警示 */
        updateUrgency(m, product, variant);

        /* 图集跳转：颜色变更时优先跳到该色第 1 张图，其次按 variant 的 featured image */
        if (m._glTotal > 1) {
          var targetIdx = -1;
          if (colorChangedValue) {
            targetIdx = findColorFirstImageIndex(product, colorChangedValue);
          }
          if (targetIdx < 0 && variant.featured_image_position > 0) {
            var posIdx = variant.featured_image_position - 1;
            if (posIdx >= 0 && posIdx < (product.images ? product.images.length : 0)) targetIdx = posIdx;
          }
          if (targetIdx < 0 && variant.featured_image_src) {
            targetIdx = findSlideIndex(product, null, variant.featured_image_src);
          }
          if (targetIdx >= 0) goToSlide(m, targetIdx);
        }
      }
  
      /* ── Build accordion items ── */
      function buildAccordions(m, product) {
        var container = m.querySelector('.v3-qs-accordions');
        container.innerHTML = '';
        var labels = product._labels || {};

        /* 合并内容：Details + Care / Shipping + Returns */
        var detailsCareParts = [];
        if (product.details_html) detailsCareParts.push(product.details_html);
        if (product.care_html)    detailsCareParts.push('<h5>Care</h5>' + product.care_html);

        var shipReturnParts = [];
        if (product.shipping_html) shipReturnParts.push('<h5>Shipping</h5>' + product.shipping_html);
        if (product.returns_html)  shipReturnParts.push('<h5>Returns</h5>'  + product.returns_html);

        var items = [
          { label: labels.details_care || 'Details + Care',    html: detailsCareParts.join(''), openDefault: true },
          { label: labels.ship_return  || 'Shipping + Returns', html: shipReturnParts.join(''),  openDefault: false }
        ];

        items.forEach(function (item) {
          if (!item.html) return;

          var acc = document.createElement('div');
          acc.className = 'v3-qs-acc-item';

          var trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'v3-qs-acc-trigger' + (item.openDefault ? ' v3-qs-open' : '');
          trigger.setAttribute('aria-expanded', item.openDefault ? 'true' : 'false');
          trigger.innerHTML = item.label +
            '<svg class="v3-qs-acc-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';

          var body = document.createElement('div');
          body.className = 'v3-qs-acc-body' + (item.openDefault ? ' v3-qs-open' : '');
          var inner = document.createElement('div');
          inner.className = 'v3-qs-acc-body-inner';
          inner.innerHTML = item.html;
          body.appendChild(inner);

          trigger.addEventListener('click', function () {
            var isOpen = trigger.classList.contains('v3-qs-open');
            container.querySelectorAll('.v3-qs-acc-trigger.v3-qs-open').forEach(function (t) {
              t.classList.remove('v3-qs-open');
              t.setAttribute('aria-expanded', 'false');
              t.nextElementSibling.classList.remove('v3-qs-open');
            });
            if (!isOpen) {
              trigger.classList.add('v3-qs-open');
              trigger.setAttribute('aria-expanded', 'true');
              body.classList.add('v3-qs-open');
            }
          });

          acc.appendChild(trigger);
          acc.appendChild(body);
          container.appendChild(acc);
        });
      }
  
      /* ── Adapt /products/{handle}.js response into the format used by the modal ── */
      function adaptProduct(raw, card) {
        var optionNames = raw.options || [];
        var options = optionNames.map(function (opt, i) {
          // 兼容 Shopify 两种返回格式：字符串数组 ["Color","Size"] 或对象数组 [{name:"Color",...}]
          var name;
          if (typeof opt === 'string') {
            name = opt;
          } else if (opt && typeof opt === 'object') {
            name = opt.name || opt.title || '';
          } else {
            name = '';
          }
          name = String(name);
  
          var values = [];
          var seen = {};
          var key = 'option' + (i + 1);
          raw.variants.forEach(function (v) {
            var val = v[key];
            if (val != null && !seen[val]) { seen[val] = true; values.push(val); }
          });
          return { name: name, position: i + 1, values: values };
        });
  
        var colorImages = {};
        var colorOpt = options.filter(function (o) {
          return o && typeof o.name === 'string' && /^colou?r$/i.test(o.name.trim());
        })[0];
        if (colorOpt) {
          var ck = 'option' + colorOpt.position;
          raw.variants.forEach(function (v) {
            var val = v[ck];
            if (val && v.featured_image && v.featured_image.src && !colorImages[val]) {
              colorImages[val] = v.featured_image.src;
            }
          });
        }
  
        var images;
        if (raw.media && raw.media.length) {
          images = raw.media.filter(function (m) { return m.media_type === 'image'; }).map(function (m, i) {
            return { id: m.id, src: m.src || m.preview_image && m.preview_image.src, thumb: (m.preview_image && m.preview_image.src) || m.src, alt: m.alt || raw.title };
          });
        } else if (raw.images && raw.images.length) {
          images = raw.images.map(function (src, i) { return { id: i, src: src, thumb: src, alt: raw.title }; });
        } else if (raw.featured_image) {
          images = [{ id: 0, src: raw.featured_image, thumb: raw.featured_image, alt: raw.title }];
        } else {
          images = [];
        }
  
        var variants = raw.variants.map(function (v) {
          return {
            id: v.id, title: v.title, available: v.available, price: v.price,
            compare_at_price: v.compare_at_price,
            option1: v.option1, option2: v.option2, option3: v.option3,
            featured_image_id:  v.featured_image ? v.featured_image.id  : null,
            featured_image_src: v.featured_image ? v.featured_image.src : null,
            featured_image_position: v.featured_image ? v.featured_image.position : null
          };
        });
  
        /* ── 读取产品级 metadata（来自 product-card-v3 的 .v3-pc__meta JSON） ── */
        var pcMeta = {};
        try {
          var metaEl = card && card.querySelector('.v3-pc__meta');
          if (metaEl) pcMeta = JSON.parse(metaEl.textContent) || {};
        } catch (e) { pcMeta = {}; }

        /* ── 读取全局 config（来自 v3-quick-add-config section） ── */
        var qaConfig = window.V3_QA_CONFIG;
        if (!qaConfig) {
          try {
            var cfgEl = document.getElementById('v3-qa-config');
            if (cfgEl) qaConfig = JSON.parse(cfgEl.textContent);
          } catch (e) {}
          window.V3_QA_CONFIG = qaConfig || { low_stock_threshold: 5, labels: {}, types: {} };
          qaConfig = window.V3_QA_CONFIG;
        }

        /* ── 按产品类型取 section 级默认（fallback 层） ── */
        var productType = pcMeta.type || raw.product_type || (card && card.dataset.productType) || '';
        var typeDefaults = null;
        if (qaConfig.types) {
          typeDefaults = qaConfig.types[productType];
          if (!typeDefaults && productType) {
            var ptLower = productType.toLowerCase().trim();
            for (var tKey in qaConfig.types) {
              if (qaConfig.types.hasOwnProperty(tKey) && tKey.toLowerCase().trim() === ptLower) {
                typeDefaults = qaConfig.types[tKey];
                break;
              }
            }
          }
        }
        typeDefaults = typeDefaults || {};
        var typeSG = (typeDefaults.size_guide) || {};
        var pcSG = pcMeta.size_guide || {};

        /* ── "产品 metafield > 类型默认 > 空" 优先级合并 ── */
        function pick() {
          for (var i = 0; i < arguments.length; i++) {
            if (arguments[i] != null && arguments[i] !== '') return arguments[i];
          }
          return '';
        }

        return {
          id: raw.id,
          title: raw.title,
          handle: raw.handle,
          type: productType,
          url: (card && card.dataset.productUrl) || raw.url || ('/products/' + raw.handle),
          description: raw.description || '',
          set_contents:  pick(pcMeta.set_contents,  typeDefaults.includes_text),
          details_html:  pick(pcMeta.details_html,  typeDefaults.details_html),
          care_html:     pick(pcMeta.care_html,     typeDefaults.care_html),
          shipping_html: pick(pcMeta.shipping_html, typeDefaults.shipping_html),
          returns_html:  pick(pcMeta.returns_html,  typeDefaults.returns_html),
          size_guide: {
            subtitle:  pick(pcSG.subtitle,  typeSG.subtitle),
            note:      pick(pcSG.note,      typeSG.note),
            html:      pick(pcSG.html,      typeSG.html),
            image_url: pick(pcSG.image_url, typeSG.image_url)
          },
          images: images,
          featured_image: raw.featured_image,
          color_images: colorImages,
          options: options,
          variants: variants,
          _inv: pcMeta.variants_inv || {},
          _threshold: (qaConfig && qaConfig.low_stock_threshold) || 5,
          _labels: (qaConfig && qaConfig.labels) || {}
        };
      }
  
      var productCache = {};

      /* Read full product data embedded in the card's <script class="v3-pc__meta">.
         Returns the parsed object only if it has variants + options (i.e., the
         expanded format). Older/partial JSON returns null so we fall back to fetch. */
      function readEmbeddedProduct(card) {
        if (!card) return null;
        try {
          var metaEl = card.querySelector('.v3-pc__meta');
          if (!metaEl) return null;
          var parsed = JSON.parse(metaEl.textContent);
          if (parsed && Array.isArray(parsed.variants) && parsed.variants.length
              && Array.isArray(parsed.options)) {
            return parsed;
          }
        } catch (e) {
          if (window.console) console.warn('[V3 QuickAdd] embedded product JSON parse failed:', e);
        }
        return null;
      }

      /* ── Open modal ── */
      function openModal(triggerBtn, handle, card) {
        var m = getModal();
        m._triggerBtn = triggerBtn;

        /* Reset */
        m.querySelector('.v3-qs-qty-input').value = 1;
        var msgEl = m.querySelector('.v3-qa-msg');
        if (msgEl) msgEl.textContent = '';
        m.querySelector('.v3-qs-title').textContent = 'Loading...';
        m.querySelector('.v3-qs-options-color').innerHTML = '';
        m.querySelector('.v3-qs-options-size').innerHTML  = '';
        m.querySelector('.v3-qs-options-other').innerHTML = '';
        m.querySelector('.v3-qs-accordions').innerHTML = '';
        var includesEl = m.querySelector('.v3-qs-includes');
        if (includesEl) { includesEl.textContent = ''; includesEl.hidden = true; }
        var urgencyEl = m.querySelector('.v3-qs-urgency');
        if (urgencyEl) urgencyEl.hidden = true;
        var submitBtn = m.querySelector('.v3-qa-submit');

        /* Cancel any stale close-modal setTimeout from a previous successful add.
           Without this, reopening the modal within 1.5s of a successful add
           would have its busy class stripped + modal closed mid-add.
           If that timer was mid-close (modal hidden) its callback would have
           restored the scroll lock — unlock defensively before cancelling so it
           can't strand. (openModal re-locks unconditionally below, so this is
           idempotent here, but keeps the cancel-vs-restore contract uniform.) */
        if (submitBtn._closeTimeout) {
          if (m.hasAttribute('hidden')) unlockBodyScroll();
          clearTimeout(submitBtn._closeTimeout);
          submitBtn._closeTimeout = null;
        }

        submitBtn.classList.add('v3-qa--busy');
        submitBtn.classList.remove('v3-qa--sold-out');
        submitBtn.dataset.variantId = '';  // 清除上次残留的 variantId，防止串货
        submitBtn.textContent = 'Loading...';

        /* Show modal immediately so user sees feedback */
        m.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';

        /* Prefer embedded product data (instant, zero HTTP requests, no 429 risk).
           Fall back to fetch only when the card lacks the expanded JSON. */
        var embedded = readEmbeddedProduct(card);
        var fetchPromise;
        if (embedded) {
          productCache[handle] = embedded;
          fetchPromise = Promise.resolve(embedded);
        } else if (productCache[handle]) {
          fetchPromise = Promise.resolve(productCache[handle]);
        } else {
          fetchPromise = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            })
            .then(function (raw) { productCache[handle] = raw; return raw; });
        }

        fetchPromise
          .then(function (raw) {
            var product = adaptProduct(raw, card);
            renderProduct(m, product);
          })
          .catch(function (err) {
            submitBtn.classList.remove('v3-qa--busy');
            submitBtn.textContent = 'Add to Cart';
            if (msgEl) {
              msgEl.textContent = 'Failed to load product. ' + (err && err.message || '');
              msgEl.style.color = '#c75050';
            }
            if (window.console) console.warn('[V3 QuickAdd] fetch failed for handle:', handle, err);
          });
      }
  
      /* ── Populate modal with product data ── */
      function renderProduct(m, product) {
        /* Gallery */
        var images = (product.images && product.images.length)
          ? product.images
          : (product.featured_image ? [{ id: 0, src: product.featured_image, thumb: product.featured_image, alt: product.title }] : []);
        buildGallery(m, images);

        /* Title */
        m.querySelector('.v3-qs-title').textContent = product.title;

        /* Includes 行（价格上方） */
        var includesEl = m.querySelector('.v3-qs-includes');
        if (includesEl) {
          if (product.set_contents) {
            includesEl.textContent = product.set_contents;
            includesEl.hidden = false;
          } else {
            includesEl.textContent = '';
            includesEl.hidden = true;
          }
        }

        /* Price defaults */
        m.querySelector('.v3-qs-price-was').style.display  = 'none';
        m.querySelector('.v3-qs-price-save').style.display = 'none';

        /* Options（拆成 color / size / other 三组） */
        var colorWrap = m.querySelector('.v3-qs-options-color');
        var sizeWrap  = m.querySelector('.v3-qs-options-size');
        var otherWrap = m.querySelector('.v3-qs-options-other');
        colorWrap.innerHTML = ''; sizeWrap.innerHTML = ''; otherWrap.innerHTML = '';

        var selected = {};
        var labels = product._labels || {};
        product._colorOptIdx = -1;

        product.options.forEach(function (opt, optIdx) {
          var nameTrim = (opt.name || '').trim();
          var isColor = /^colou?r$/i.test(nameTrim) || /颜色/.test(nameTrim);
          var isSize  = /^size$/i.test(nameTrim) || /尺寸|尺码/.test(nameTrim);

          if (isColor) product._colorOptIdx = optIdx;

          var group = document.createElement('div');
          group.className = 'v3-qs-opt-group';

          var head = document.createElement('div');
          head.className = 'v3-qs-opt-head';

          var nameEl = document.createElement('span');
          nameEl.className = 'v3-qs-opt-name';
          if (isColor) {
            nameEl.innerHTML = opt.name + ':<strong class="v3-qs-opt-val-' + opt.position + '">' + opt.values[0] + '</strong>';
          } else {
            nameEl.textContent = opt.name;
          }
          head.appendChild(nameEl);

          /* Size 右侧：Size Guide 按钮 */
          if (isSize && (product.size_guide && (product.size_guide.image_url || product.size_guide.html))) {
            var sgBtn = document.createElement('button');
            sgBtn.type = 'button';
            sgBtn.className = 'v3-qs-size-guide';
            sgBtn.innerHTML = (labels.size_guide || 'Size Guide') +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
            sgBtn.addEventListener('click', function () { openSizeGuide(m, product); });
            head.appendChild(sgBtn);
          }

          group.appendChild(head);

          if (isColor) {
            var colorsRow = document.createElement('div');
            colorsRow.className = 'v3-qs-colors';
            opt.values.forEach(function (val, idx) {
              var item = document.createElement('button');
              item.type = 'button';
              item.className = 'v3-qs-color-item' + (idx === 0 ? ' v3-qs-active' : '');

              var sw = document.createElement('span');
              sw.className = 'v3-qs-swatch';
              var imgUrl = product.color_images && product.color_images[val];
              if (imgUrl) {
                sw.style.backgroundImage = 'url(' + imgUrl + ')';
                sw.innerHTML = '<img src="' + imgUrl + '" alt="' + val + '">';
              } else {
                sw.style.backgroundColor = val.toLowerCase().replace(/\s+/g, '');
              }
              sw.insertAdjacentHTML('beforeend',
                '<svg class="v3-qs-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>');
              item.appendChild(sw);

              var nm = document.createElement('span');
              nm.className = 'v3-qs-color-name';
              nm.textContent = val;
              item.appendChild(nm);

              if (idx === 0) selected[opt.position] = val;

              item.addEventListener('click', function () {
                colorsRow.querySelectorAll('.v3-qs-color-item').forEach(function (b) {
                  b.classList.remove('v3-qs-active');
                });
                item.classList.add('v3-qs-active');
                selected[opt.position] = val;
                var labelEl = head.querySelector('.v3-qs-opt-val-' + opt.position);
                if (labelEl) labelEl.textContent = val;
                syncVariant(m, product, selected, val);
              });
              colorsRow.appendChild(item);
            });
            group.appendChild(colorsRow);
            colorWrap.appendChild(group);
          } else {
            var btnsRow = document.createElement('div');
            btnsRow.className = isSize ? 'v3-qs-sizes' : 'v3-qs-sizes';
            opt.values.forEach(function (val, idx) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'v3-qs-sz' + (idx === 0 ? ' v3-qs-sz--active' : '');
              btn.textContent = val;
              if (idx === 0) selected[opt.position] = val;
              btn.addEventListener('click', function () {
                btnsRow.querySelectorAll('.v3-qs-sz').forEach(function (b) { b.classList.remove('v3-qs-sz--active'); });
                btn.classList.add('v3-qs-sz--active');
                selected[opt.position] = val;
                syncVariant(m, product, selected);
              });
              btnsRow.appendChild(btn);
            });
            group.appendChild(btnsRow);
            (isSize ? sizeWrap : otherWrap).appendChild(group);
          }
        });

        syncVariant(m, product, selected);

        /* Accordions（2 项：Details + Care / Shipping + Returns） */
        buildAccordions(m, product);

        /* VIEW FULL DETAILS */
        var fullLink = m.querySelector('.v3-qs-full-link');
        fullLink.href = product.url || '#';
        fullLink.textContent = (labels.view_full || 'View Full Details') + ' \u2192';

        /* Add to Cart 默认标签（syncVariant 会基于库存覆写） */
        var submitBtn = m.querySelector('.v3-qa-submit');
        if (submitBtn && !submitBtn.dataset.variantId) {
          submitBtn.textContent = labels.add_to_cart || 'Add to Cart';
        }

        setTimeout(function () { m.querySelector('.v3-qs-close').focus(); }, 60);
      }

      /* ── 打开 Size Guide 弹窗，写入当前产品的内容 ── */
      function openSizeGuide(m, product) {
        var sg = m.querySelector('#v3-qs-sg-modal');
        if (!sg) return;
        var labels = product._labels || {};
        sg.querySelector('.v3-qs-sg-ttl').textContent = labels.size_guide || 'Size Guide';

        var subEl = sg.querySelector('.v3-qs-sg-sub');
        var noteEl = sg.querySelector('.v3-qs-sg-note');
        var imgEl = sg.querySelector('.v3-qs-sg-img');
        var cntEl = sg.querySelector('.v3-qs-sg-cnt');
        var g = product.size_guide || {};

        if (g.subtitle) { subEl.textContent = g.subtitle; subEl.hidden = false; }
        else            { subEl.textContent = ''; subEl.hidden = true; }

        if (g.image_url) { imgEl.src = g.image_url; imgEl.hidden = false; }
        else             { imgEl.removeAttribute('src'); imgEl.hidden = true; }

        if (g.note) { noteEl.textContent = g.note; noteEl.hidden = false; }
        else        { noteEl.textContent = ''; noteEl.hidden = true; }

        cntEl.innerHTML = g.html || '';
        sg.classList.add('v3-qs-open');
      }
  
      /* Expose modal opener so other sections (e.g. V4 collection page) can
         trigger Quick Add directly without relying on the global click delegation.
         Usage: window.v3OpenQuickAdd(handle, card, triggerBtn) */
      window.v3OpenQuickAdd = function (handle, card, triggerBtn) {
        if (!handle) return;
        openModal(triggerBtn || null, handle, card || null);
      };

      /* ── Event delegation (capture phase so we run before any bubbling
            handler that might otherwise navigate or intercept) ── */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.v3-pc__quick-add');
        if (!btn) return;
        if (btn.classList.contains('v3-qa--sold-out') || btn.hasAttribute('disabled')) return;
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.v3-pc');
        var handle = btn.dataset.productHandle || (card && card.dataset.productHandle);
        if (!handle) {
          if (window.console) console.warn('[V3 QuickAdd] missing data-product-handle on button or card');
          return;
        }
        openModal(btn, handle, card);
      }, true);
    }
  
    /* ----------------------------------------------------------
       INIT
    ---------------------------------------------------------- */
    function init() {
      initReveal();
      initProductTabs();
      initSwatches();
      initQuickAdd();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();